<template>
	<div>
		<form id="generalForm" class="form-layout form-layout-2">
			<div class="alert alert-danger" v-if="hasWithoutOperationalTeamAlert">
				<span class="text-bold uppercase">
					<i class="fa fa-exclamation-circle"></i>
					Cliente sem time operacional informado
				</span>
				<br />
				<span>
					Atenção! O cliente deste processo não possui time operacional
					informado para processos do tipo
					<strong>{{ model.typeOfProcess | typeOfProcess }}</strong>!
					<a href="#" @click.prevent="openCustomerTeamsModal">Clique aqui</a> para informar os times do cliente.
				</span>
			</div>
			<div class="alert alert-danger" v-if="hasWithoutCustomsTeamAlert && model.customer">
			<!-- <div class="alert alert-danger">  -->
				<span class="text-bold uppercase">
					<i class="fa fa-exclamation-circle"></i>
					Cliente sem time aduaneiro
				</span>
				<br />
				<span>
					Atenção: O cliente deste processo não possui time aduaneiro vinculado.
					<a href="#" @click.prevent="openCustomerTeamsModal">Clique aqui</a> para informar os times do cliente.
				</span>
			</div>
			<!-- form-group  -->
			<div class="pt-3 pb-3 bd-b-0-force">
              <div class="flex gap2">
                <v-checkbox classLabel="tx-12" :small="true" name="importLicense" label="LICENÇAS" v-model="model.importLicense" />
                <v-checkbox classLabel="tx-12" :small="true" name="urgent" label="URGENTE" v-model="model.urgent" :red="true" />
                <v-checkbox classLabel="tx-12" :small="true" name="imo" label="IMO" v-model="model.imo" />
                <v-checkbox classLabel="tx-12" :small="true" name="duimp" label="DUIMP" v-model="model.duimp" />
                <v-checkbox classLabel="tx-12" :small="true" name="productCatalog" label="CATÁLOGO" v-model="model.productCatalog" />
                <v-checkbox classLabel="tx-12" :small="true" name="administrativeTreatmentDone" label="TA FEITO" v-model="model.administrativeTreatmentDone" @input="inputAdministrativeTreatmentDone"/>
                <v-checkbox classLabel="tx-12" :small="true" name="priority" label="PRIORIDADE" v-model="model.priority" />
				<v-checkbox classLabel="tx-12" :small="true" name="drawback" label="DRAWBACK" v-model="model.drawback" />
              </div>
            </div>	
			
			<div class="row no-gutters">
				<div class="col-md-2">
					<div class="form-group flex fd-c jc-c">
						<input v-model="model.identification" class="form-control tx-34 tx-center tx-bolder tx-white"
							name="identification" readonly @click="changeIdentification" />
						<label class="form-control-label tx-center tx-thin">
							Referência Interna
							<br />
							<span class="tx-bold">
								{{ model.account ? model.account.alias : "" }}
							</span>
						</label>
					</div>
				</div>
				<div :class="{ 'col-md-8': model.priority, 'col-md-10': !model.priority }">
					<div>
						<div class="row no-gutters">
							<div class="form-group bd-l-0-force col-md-12 status-field--operation">
								<div class="flex gap1 ai-c">
									<label class="form-control-label">Status da Operação</label>
									<small v-if="model.operationStatusLastModifiedBy">
										(Alterado pela última vez em
										{{
											model.operationStatusDateOfLastModify
											| moment("DD/MM/YY à\\s H:mm:ss")
										}}
										por {{ model.operationStatusLastModifiedBy }})
									</small>
								</div>
								<input v-model="model.operationStatus" class="form-control tx-20" name="operationStatus" type="text" />
							</div>
							<hr />
							<div class="form-group bd-l-0-force bd-t-0-force col-md-12 status-field--quick" >
								<div class="flex gap1 ai-c">
									<label class="form-control-label">Status do Cliente (Portal do Cliente)</label>
									<small v-if="model.statusLastModifiedBy">
										(Alterado pela última vez em
										{{
											model.statusDateOfLastModify
											| moment("DD/MM/YY à\\s H:mm:ss")
										}}
										por {{ model.statusLastModifiedBy }})
									</small>
								</div>
								<input v-model="model.status" class="form-control tx-20" name="status" type="text" />
							</div>
							<hr />
							<div class="form-group bd-l-0-force bd-t-0-force col-md-12" :class="(!model.customBroker || (model.customBroker && model.customBroker.federalID !== '08.214.494/0001-19')) ? 'bg-gray-100' : 'status-field--broker'">
								<div class="flex gap1 ai-c">
									<label class="form-control-label">Status do Despachante Aduaneiro</label>
									<small v-if="model.statusCustomBrokerLastModifiedBy">
										(Alterado pela última vez em
										{{
											model.statusCustomBrokerDateOfLastModify
											| moment("DD/MM/YY à\\s H:mm:ss")
										}}
										por {{ model.statusCustomBrokerLastModifiedBy }})
									</small>
								</div>
								<input v-model="model.statusCustomBroker" class="form-control tx-20" name="statusCustomBroker" type="text" :disabled="!model.customBroker || (model.customBroker && model.customBroker.federalID !== '08.214.494/0001-19')" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-2" v-if="priorityReady">
					<div class="form-group bd-l-0-force">
						<label class="form-control-label"> Tipo de Prioridade </label>
						<multi-select telao :config="{
								options: priorityTypes,
								searchable: true,
								label: 'description',
								trackBy: 'id',
								placeholder: '',
								multiple: true,
							}" 
							@input="changePriorityTypes($event)"
							:searchable="false"
							deselectLabel="X"
							:allowEmpty="true"
							v-model="model.priorityTypes"
						>
						</multi-select>
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-2">
					<div class="form-group bd-b-0-force mg-md-t--1">
						<label class="form-control-label"> Tipo de Processo </label>
						<select v-model="model.typeOfProcess" class="custom-select form-control" name="typeOfProcess"
							@change.prevent="changeTypeOfProcess">
							<option v-for="typeOfProcess in listOfTypeOfProcess" :key="typeOfProcess.key"
								:value="typeOfProcess.key">
								{{ typeOfProcess.value }}
							</option>
						</select>
					</div>
				</div>

				<div class="col-md-4">
					<div class="form-group bd-t-0-force bd-l-0-force">
						<label class="form-control-label"> Empresa / Filial </label>
						<v-select
							ref="accountSelect"
							v-model="model.account"
							:on-search="getAccounts"
							:options="search_accounts"
							:clearable="false"
							label="name"
							name="account"
							@search="onAccountSearchEmitted"
							@search:focus="syncAccountSearchQueryFromSelect"
							@search:blur="syncAccountSearchQueryFromSelect"
						>
							<template slot="option" slot-scope="option">
								{{ option.federalID }} <strong>{{ option.alias }}</strong>
							</template>
							<template slot="no-options">
								<span v-if="!String(accountSearchQuery || '').trim()">Digite para buscar</span>
								<span v-else>Não encontrado</span>
							</template>
						</v-select>
						<span v-show="errors.has('search_accounts')" class="parsley-errors-list filled">Selecione a Empresa</span>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-t-0-force bd-l-0-force bd-b-0-force mg-md-t--1">
						<label class="form-control-label"> Time Operacional </label>
						<v-select v-model="model.team" :options="teamsOptions" label="name" name="team" :clearable="false">
							<template slot="option" slot-scope="option">{{ option.name }}</template>
						</v-select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group bd-t-0-force bd-l-0-force bd-b-0-force mg-md-t--1">
						<label class="form-control-label"> Time Aduaneiro </label>
						<v-select v-model="model.customsTeam" :options="customsTeamOptions" label="name" name="customsTeam" :clearable="false">
							<template slot="option" slot-scope="option">{{ option.name }}</template>
						</v-select>
					</div>
				</div>

				<div class="col-md-6">
					<div class="form-group  bd-b-0-force mg-md-t--1">
						<label class="form-control-label"> Despachante Aduaneiro </label>
						<v-select v-model="model.customBroker" :on-search="getCustomersBrokers"
							:options="optionsCustomersBrokers" label="name" name="customBroker">
							<template slot="option" slot-scope="option">{{ option.federalID }} | {{ option.name
								}}</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>
                <!-- <div class="col-md-3" :class="{ 'col-md-4': model.processUseOfGoods && model.processUseOfGoods.length >= 3 }"></div> -->
				<div class="col-md-6">
					<div class="form-group mg-md-t--1 bd-t-1-force bd-l-0-force bd-b-0-force">
						<label class="form-control-label"> Destinação Mercadorias </label>
						<multi-select telao :config="{
								options: listOfUseOfGoods,
								searchable: true,
								label: 'description',
								trackBy: 'code',
								placeholder: '',
								multiple: true,
							}" 
							@input="changeProcessUseOfGoods($event)"
							:searchable="false"
							deselectLabel="X"
							:allowEmpty="true"
							v-model="model.processUseOfGoods"
						>
						</multi-select>
						
					</div>
				</div>

				<div class="col-md-6">
					<div class="form-group mg-md-t--1">
						<label class="form-control-label">Cliente</label>
						<div class="flex ai-c" style="gap: 5px;">
							<div class="flex1">
								<multi-select telao 
									:config="{
										options: customers,
										closeOnSelect: true,
										label: 'name',
										trackBy: 'id',
										placeholder: 'Selecione um cliente',
										tagPlaceholder: 'Adicionar cliente',
									}" 
									v-model="model.customer"
								>
									<template #noResult>
										Nenhum cliente encontrado. Deseja
										<a href="#" @click.prevent="modalContactOpen = true">criar um novo cliente</a>?
									</template>
								</multi-select>
							</div>
							<div class="flex ai-c" style="gap: 5px; flex-shrink: 0;">
								<span v-if="model.customer && model.customer.salesRadarModality" 
									class="badge badge-light tx-12" 
									:class="{ 'limited': model.customer.salesRadarModality === 'LIMITED_50' || model.customer.salesRadarModality === 'LIMITED' }"
									style="cursor: default; border-radius: 7px"
									@click="showSalesRadarModal()"
								>
									<i class="fa fa-list-ul" aria-hidden="true" v-if="model.customer.salesRadarModality === 'LIMITED_50' || model.customer.salesRadarModality === 'LIMITED'"></i>
									RADAR
									<strong v-if="model.customer.salesRadarModality === 'LIMITED_50'">LIMITADO USD 50k </strong>
									<strong v-if="model.customer.salesRadarModality === 'LIMITED'">LIMITADO USD 150k </strong>
									<strong v-if="model.customer.salesRadarModality === 'ILIMITED'">ILIMITADO </strong>
									<strong v-if="model.customer.salesRadarModality === 'NOT_ENABLED_TO_IMPORT'">NÃO HABILITADO PARA IMPORTAÇÃO </strong>
								</span>
								<span v-if="model.customer && model.customer.hasProductsCatalog" class="badge tx-12" style="cursor: default; color: white; background-color: #5B93D3; border-radius: 7px;" title="Catálogo de Produtos Prime">
									<strong>CATÁLOGO</strong>
								</span>
								<span
									v-if="model.customer && taxRegimeLabel(model.customer.taxRegime)"
									class="badge tx-12"
									:style="{
										cursor: model.customer.taxRegime === 'SIMPLES' ? 'pointer' : 'default',
										color: 'white',
										backgroundColor: '#395B64',
										borderRadius: '7px',
										textTransform: 'uppercase',
									}"
									:title="model.customer.taxRegime === 'SIMPLES' ? 'Regime fiscal' : null"
									@click="model.customer.taxRegime === 'SIMPLES' && showTaxRegime()"
								>
									<strong>{{ taxRegimeLabel(model.customer.taxRegime) }}</strong>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="col-6">
					<div class="form-group mg-md-t--1 bd-l-0-force">
						<label class="form-control-label">Ref Pedido/ Cliente</label>
						<input v-model="model.customerRef" class="form-control" name="customerRef" type="text" />
					</div>
				</div>

				<div class="col-6">
					<div class="form-group mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Exportador</label>
						<v-select v-model="model.exporter" :on-search="getExporters" :options="optionsExporters"
							label="name" name="exporter">
							<template slot="option" slot-scope="option">{{ option.federalID }} | {{ option.name }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>

				<div class="col-6">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label">Fabricante/Produtor</label>
						<v-select v-model="model.manufacturer" :on-search="getExporters" :options="optionsExporters"
							label="name" name="manufacturer">
							<template slot="option" slot-scope="option">{{ option.federalID }} | {{ option.name }}
							</template>
						</v-select>
					</div>
				</div>

				<div class="col-6">
					<div class="form-group mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Invoice</label>
						<input v-model="model.invoice" class="form-control" name="invoice" type="text" />
					</div>
				</div>

				<div class="col-2">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label">Data da Invoice</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.invoiceDate" v-validate="'required'" class="form-control"
									format="DD/MM/YY" inputName="invoiceDate" lang="pt-br" name="invoiceDate"
									placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-4">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label">Local de Embarque</label>
						<div v-if="model.placeOfLoadingEntity || !model.placeOfLoading">
							<multi-select telao 
								:config="{
									options: placeOfLoadingOptions,
									closeOnSelect: true,
									taggable: true,
									label: 'name',
									trackBy: 'id',
									placeholder: '',
									tagPlaceholder: 'Adicionar',
								}" 
								:clearable="true"
								:allowEmpty="true"
								v-model="model.placeOfLoadingEntity"
								@tag="addPlaceOfLoading"
								@clear="clearPlaceOfLoading"
							>
								<template slot="option" slot-scope="{ option }">
									<div class="option__desc">{{ option.name || option.label }}</div>
								</template>
							</multi-select>
						</div>
						<div v-if="model.placeOfLoading && !model.placeOfLoadingEntity">
							<input v-model="model.placeOfLoading" :disabled="abertaField" class="form-control" name="placeOfLoading" type="text" />
						</div>
					</div>
				</div>

				<div class="col-4">
					<div class="form-group mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Valor Total de Invoices (Previsto)</label>
						<money v-model="model.invoiceTotal" class="form-control" name="invoiceTotal" type="text"
							v-bind="money" />
						<span class="badge badge-danger" v-if="invoiceInconsistence">
							{{ invoiceInconsistence }}
						</span>
					</div>
				</div>

				<div class="col-2">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label"> Valor VMLD </label>
						<money v-model="model.cifValue" class="form-control" name="cifValue" v-bind="money"></money>
					</div>
				</div>

				<div class="col-2">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label">Moeda (VMLD / Invoice)</label>
						<v-select :value="model.cifValueCurrency"
							@input="(coin) => (model.cifValueCurrency = coin.value)" :options="coinOptions"
							label="label" :clearable="false" name="cifValueCurrency">
						</v-select>
					</div>
				</div>

				<div class="col-4">
					<div class="form-group mg-md-t--1 bd-l-0-force bd-t-0-force">
						<label class="form-control-label"> Outra Referência</label>
						<input v-model="model.anotherRef" class="form-control" name="anotherRef" type="text" />
					</div>
				</div>
			</div>

			<label class="section-title mg-t-20">Informações de Logística</label>

			<div class="row no-gutters">
				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Incoterm</label>
						<!-- v-model="model.incoterm" -->
						<select :value="model.incoterm" @change="validaIncoterm"
							class="custom-select form-control wd-150" name="incoterm">
							<option value></option>
							<option v-for="incoterm in listOfIncoterms" :key="incoterm.key" :value="incoterm.key">
								{{ incoterm.key }}
							</option>
						</select>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Via de transporte</label>
						<div class="flex ai-c fw-w">
							<v-select v-model="model.wayOfTransport" :options="listOfWayOfTransport" index="key"
								label="value" name="shipowner" @input="changeWayOfTransport" style="flex: 1"
								class="input-way-of-transport">
								<template slot="option" slot-scope="option">
									{{ option.value }}
								</template>
							</v-select>
							<span v-show="(model.wayOfTransport == 'MARITIMA' ||
									model.wayOfTransport == 'AEREA') &&
								model.daysToStepCashRequestCalculation != null
								" class="badge badge-light tx-12" style="cursor: default; border-radius: 7px">
								<strong>
									{{ model.daysToStepCashRequestCalculation }} DIAS
								</strong>
							</span>
						</div>
					</div>
				</div>

				<div class="col-md-4">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Armador</label>
						<v-select v-model="model.shipowner" :on-search="getShipowners" :options="optionsShipowners"
							label="name" name="shipowner">
							<template slot="option" slot-scope="option">
								{{ option.federalID }} | {{ option.name }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group mg-md-t--1 bd-r-0-force">
						<label class="form-control-label">BL/AWB/CRT</label>
						<input v-model="model.billOfLading" :disabled="abertaField" class="form-control"
							name="billOfLading" type="text" />
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group mg-md-t--1">
						<label class="form-control-label">MASTER</label>
						<input v-model="model.billOfLadingMaster" :disabled="abertaField" class="form-control"
							name="billOfLadingMaster" type="text" />
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-2">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Tipo de embarque</label>
						<select v-model="model.typeOfBoarding" class="custom-select form-control wd-150"
							name="typeOfBoarding">
							<option value="SEM">Nenhum</option>
							<option v-for="typeOfBoarding in listOfTypeOfBoarding" :key="typeOfBoarding.key"
								:value="typeOfBoarding.key">
								{{ typeOfBoarding.value }}
							</option>
						</select>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label"> Freetime </label>
						<input v-model="model.freetime" :disabled="abertaField" class="form-control" name="freetime"
							type="tel" v-mask="'###'" />
					</div>
				</div>

				<div :class="model.wayOfTransport == 'MARITIMA' ? 'col-md-2' : 'col-md-4'">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Navio de Embarque </label>
						<div v-if="model.vehicleTranshipmentEntity || !model.vehicleTranshipment">
							<multi-select telao 
								:config="{
									options: vehicleOptions,
									closeOnSelect: true,
									taggable: true,
									label: 'name',
									trackBy: 'id',
									placeholder: '',
									tagPlaceholder: 'Adicionar',
								}" 
								:clearable="true"
								:allowEmpty="true"
								v-model="model.vehicleTranshipmentEntity"
								@tag="addVehicleTranshipment"
								@clear="clearVehicleTranshipment"
							>
								<template slot="option" slot-scope="{ option }">
									<div class="option__desc">{{ option.name || option.label }}</div>
								</template>
							</multi-select>
						</div>
						<div v-if="model.vehicleTranshipment && !model.vehicleTranshipmentEntity">
							<input v-model="model.vehicleTranshipment" class="form-control" name="vehicleTranshipment" type="text" />
						</div>
					</div>
				</div>

				<div :class="model.wayOfTransport == 'MARITIMA' ? 'col-md-2' : 'col-md-4'">
					<div class="form-group bd-t-0-force mg-md-t--1" :class="model.wayOfTransport == 'MARITIMA' ? 'bd-r-0-force' : ''">
						<label v-if="model.wayOfTransport == 'MARITIMA'" class="form-control-label">Navio de Transbordo (Atual)</label>
						<label v-else class="form-control-label">Veículo</label>
						<div v-if="model.vehicleEntity || !model.vehicle">
							<multi-select telao 
								:config="{
									options: vehicleOptions,
									closeOnSelect: true,
									taggable: true,
									label: 'name',
									trackBy: 'id',
									placeholder: '',
									tagPlaceholder: 'Adicionar',
								}" 
								:clearable="true"
								:allowEmpty="true"
								v-model="model.vehicleEntity"
								@tag="addVehicle"
								@clear="clearVehicle"
							>
								<template slot="option" slot-scope="{ option }">
									<div class="option__desc">{{ option.name || option.label }}</div>
								</template>
							</multi-select>
						</div>
						<div v-if="model.vehicle && !model.vehicleEntity">
							<input v-model="model.vehicle" class="form-control" name="vehicle" type="text" />
						</div>
						
					</div>
				</div>

				<div class="col-md-2" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Nº Booking </label>
						<input v-model="model.booking" class="form-control" name="booking"
							type="text" />
					</div>
				</div>

				<div class="col-md-2" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-t-0-force mg-md-t--1">
						<label class="form-control-label"> Viagem </label>
						<input v-model="model.voyageNumber" :disabled="abertaField" class="form-control" name="voyageNumber"
							type="text" />
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-4">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Forwarder</label>
						<v-select v-model="model.freightForwarder" :on-search="getForwarders"
							:options="optionsForwarders" label="name" name="freightForwarder">
							<template slot="option" slot-scope="option">
								{{ option.federalID }} | {{ option.name }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group bd-t-0-force mg-md-t--1 bd-r-0-force">
						<label class="form-control-label">Porto / Aeroporto de Destino</label>
						<v-select v-model="model.destinationPort" :on-search="getCustomsEnclosures"
							:options="optionsCustomsEnclosures" label="alias" name="destinationPort">
							<template slot="option" slot-scope="option">
								{{ option.code }} | {{ option.alias }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group bd-t-0-force mg-md-t--1">
						<label class="form-control-label">Recinto Alfandegado</label>
						<v-select v-model="model.customsEnclosure" :on-search="getCustomsEnclosures"
							:options="optionsCustomsEnclosures" label="alias" name="customsEnclosure">
							<template slot="option" slot-scope="option">
								{{ option.code }} | {{ option.alias }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-4">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Transportadora</label>
						<v-select v-model="model.conveyor" :on-search="getCompanies" :options="optionsCompanies"
							label="name" name="conveyor">
							<template slot="option" slot-scope="option">
								{{ option.federalID }} | {{ option.name }}
							</template>
							<slot name="no-options">Não encontrado</slot>
						</v-select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group bd-t-0-force bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Armazém Geral</label>
						<v-select v-model="model.generalWarehouse" :on-search="getCompanies" :options="optionsCompanies"
							label="name" name="generalWarehouse">
							<template slot="option" slot-scope="option">
								{{ option.federalID }} | {{ option.name }}
							</template>
						</v-select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group bd-t-0-force mg-md-t--1 form-field-inline-group">
						<div class="form-field-inline-group__head d-flex justify-content-between align-items-center">
							<label class="form-control-label form-field-inline-group__label mg-b-0">
								Nº CE-Mercante
							</label>
							<a
								v-if="ceMercanteValid && model.id"
								href="#"
								class="form-field-inline-group__action text-nowrap"
								:disabled="abertaField"
								@click="consultarCeMercanteMarinha"
							>
								Consultar CE Mercante
							</a>
						</div>
						<div class="d-flex align-items-center form-field-inline-group__row">
							<div class="form-field-inline-group__primary">
								<input v-model="model.ceMercante" :disabled="abertaField" class="form-control" name="ceMercante"
									type="text" maxlength="15" autocomplete="off" placeholder="Ex.: 172605066933873" v-mask="'###############'" />
							</div>
							<div class="form-field-inline-group__secondary" v-if="ceMercanteValid && model.id">
								<process-conference-select
									:value="model.ceMercanteChecked"
									name="ceMercanteChecked"
									:disabled="abertaField"
									aria-label="Conferência CE Mercante"
									@input="setCeMercanteConference"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-6">
					<label class="section-title mg-t-10">Etapas/Seguro</label>
				</div>
				<div class="col-md-6"></div>
			</div>
			<div class="row no-gutters">
				<div class="col-md-4">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Planilha</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.stepSpreadsheet" v-validate="'required'"
									class="form-control" format="DD/MM/YY" inputName="stepSpreadsheet" lang="pt-br"
									name="stepSpreadsheet" placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after"></div>
						</div>
					</div>
				</div>

				<div class="col-md-4">
					<div class="form-group mg-md-t--1 bd-r-0-force">
						<label class="form-control-label">Quem vai fazer o seguro?</label>
						<div class="input-group-solved">
							<!-- v-model="model.stepInsuranceValueResponsability" -->
							<select :value="model.stepInsuranceValueResponsability" @change="validaResponsavelSeguro"
								class="custom-select form-control" name="stepInsuranceValueResponsability">
								<option value="PRIME">A Prime</option>
								<option value="CLIENTE">O Cliente</option>
								<option value="NAO_SE_APLICA">Não se Aplica</option>
							</select>
						</div>
						<!--          <div class="badge badge-info mt-1 p-1">Resposável Padrão: <span v-if="model.customer && model.customer.insuranceWithPrime">Prime</span><span class="text-medium" v-else> Cliente</span></div>-->
					</div>
				</div>

				<div class="col-4 mg-l-0">
					<div class="form-group mg-md-t--1 bd-l-0-force">
						<label class="form-control-label">Resposável Padrão</label>
						<div class="input-group-solved-after">
							<div class="input-group-solved tx-normal tx-black"
								v-if="model.customer && model.customer.insuranceWithPrime">
								<div class="input-group-solved-before">
									<i class="fa fa-thumbs-up tx-success"></i>
								</div>
								<div class="input-group-solved-center">Prime</div>
							</div>
							<div class="input-group-solved tx-normal tx-black" v-else>
								<div class="input-group-solved-before">
									<i class="fa fa-thumbs-down tx-danger"></i>
								</div>
								<div class="input-group-solved-center">Cliente</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-8">
					<label class="section-title mg-t-10">Documentos Originais</label>
				</div>
				<div class="col-md-4">
					<label class="section-title mg-t-10">Conferência</label>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Documentos</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.originalsDocumentsDate" v-validate="'required'"
									:disabled="abertaField" class="form-control" format="DD/MM/YY"
									inputName="originalsDocumentsDate" lang="pt-br" name="originalsDocumentsDate"
									placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.originalsDocumentsDateSolved"
										name="originalsDocumentsDateSolved" type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Conhecimento</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.originalsBillOfLadingDate" v-validate="'required'"
									class="form-control" format="DD/MM/YY" inputName="originalsBillOfLadingDate"
									lang="pt-br" name="originalsBillOfLadingDate" placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.originalsBillOfLadingDateSolved"
										name="originalsBillOfLadingDateSolved" type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Fatura</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.originalsInvoiceDate" v-validate="'required'"
									class="form-control" format="DD/MM/YY" inputName="originalsInvoiceDate" lang="pt-br"
									name="originalsInvoiceDate" placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.originalsInvoiceDateSolved" name="originalsInvoiceDateSolved"
										type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Packing List</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.originalsPackingListDate" v-validate="'required'"
									class="form-control" format="DD/MM/YY" inputName="originalsPackingListDate"
									lang="pt-br" name="originalsPackingListDate" placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.originalsPackingListDateSolved"
										name="originalsPackingListDateSolved" type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-4">
					<div class="form-group mg-md-t--1 pd-b-0--force">
						<div class="row">
							<div class="col-lg-6">
								<div class="input-group-solved">
									<div class="input-group-solved-before">
										<toggle-button v-model="model.conferenceDocumentsSolved"
											:color="{ unchecked: '#bf0909' }" :height="16"
											:labels="{ checked: 'CONF', unchecked: 'PEND' }" :sync="true" :width="60"
											name="conferenceDocumentsSolved" />
									</div>
									<div class="input-group-solved-after wd-100 mg-l-10">
										<label class="form-control-label">Documentos</label>
									</div>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="input-group-solved">
									<div class="input-group-solved-before">
										<toggle-button v-model="model.conferenceBillOfLadingSolved"
											:color="{ unchecked: '#bf0909' }" :height="16"
											:labels="{ checked: 'CONF', unchecked: 'PEND' }" :sync="true" :width="60"
											name="conferenceBillOfLadingSolved" />
									</div>
									<div class="input-group-solved-after wd-100 mg-l-10">
										<label class="form-control-label">Conhecimento</label>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-6">
								<div class="input-group-solved">
									<div class="input-group-solved-before">
										<toggle-button v-model="model.conferenceInvoiceSolved"
											:color="{ unchecked: '#bf0909' }" :height="16"
											:labels="{ checked: 'CONF', unchecked: 'PEND' }" :sync="true" :width="60"
											name="conferenceInvoiceSolved" />
									</div>
									<div class="input-group-solved-after wd-100 mg-l-10">
										<label class="form-control-label">Fatura/Invoice</label>
									</div>
								</div>
							</div>

							<div class="col-lg-6">
								<div class="input-group-solved">
									<div class="input-group-solved-before">
										<toggle-button v-model="model.conferencePackingListSolved"
											:color="{ unchecked: '#bf0909' }" :height="16"
											:labels="{ checked: 'CONF', unchecked: 'PEND' }" :sync="true" :width="60"
											name="conferencePackingListSolved" />
									</div>
									<div class="input-group-solved-after wd-100 mg-l-10">
										<label class="form-control-label tx-12">Packing List</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row no-gutters" v-if="!model?.duimp">
				<div class="col-md-12">
					<label class="section-title mg-t-10">Declaração de Importação</label>
				</div>
			</div>

			<div class="row no-gutters" v-if="!model?.duimp">
				<div class="col-md-3">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">
							Número do Protocolo da DI
						</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-info op-5"></i>
							</div>
							<div class="input-group-solved-center wd-150">
								<input v-model="model.diProtocol" class="form-control wd-200" name="diProtocol"
									type="text" />
							</div>
							<div class="input-group-solved-after"></div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Número do Registro</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-info op-5"></i>
							</div>
							<div class="input-group-solved-center wd-150">
								<input v-model="model.diNumber" v-mask="'##/#######-#'" class="form-control wd-200"
									name="diNumber" type="text" />
							</div>
							<div class="input-group-solved-after mg-l-10">
								<i v-if="
									model.diNumber !== undefined &&
									model.diNumber !== null &&
									model.diNumber !== '' &&
									model.diNumber.length >= 10
								" class="fa fa-check tx-success"></i>
								<i v-else class="fa fa-check tx-danger"></i>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="form-group bd-l-0-force mg-md-t--1">
						<div>
							<a class="text-info text-sm mt-3" @click="openModal" href="#">
								<i class="fa fa-info-circle"></i> Agora você não precisa mais
								consultar as DIs <br />
								Clique aqui para saber como está funcionado!
							</a>

							<VModal title="Consultar DIs"
								description="Veja o que mudou em relação a nova forma de consultar DI." :width="600"
								@requestClose="closeModal" :handler="isOpenModal">
								<template #content>
									<div>
										<p>
											Com o intuito de automatizar o processo e reduzir
											inconsistências, mudamos o processo padrão de consulta de
											DI. Agora o processo é feito automaticamente ao fazer o
											upload do XML da DI para os documentos, porém é necessário
											que o campo <strong>NÚMERO DA DI</strong> e
											<strong>PROTOCOLO</strong> estejam preenchidos.
											<br />
											<br />
											Antes de consultar a DI no Siscomex, o Gescomex efetua
											algumas verificações para garantir a integridades das
											informações, são elas:
										</p>
										<ul class="mg-t-0">
											<li>
												Verifica se o Número da DI que está no XML é o mesmo
												informado no processo;
											</li>
											<li>
												Verificado o CNPJ do Cliente no XML com o informado no
												cadastro do cliente de processo;
											</li>
										</ul>

										<p>
											Além das verificações, após o upload do XML ser efetuado
											com sucesso, o sistema salva automaticamente as seguintes
											informações:
										</p>
										<ul class="mg-t-0">
											<li>Data de Registro;</li>
											<li>Data de Desembaraço;</li>
										</ul>

										<hr />

										<h5><strong>Automações adicionais: </strong></h5>
										<p>
											Ao fazer upload da CI, o sistema irá consultar
											automaticamente a DI no Sicomex, para manter o processo
											atualizado.
											<br />
											<br />
											Quando o processo for da Duas Rodas e tiver embarque
											informado na aba de integração, o Gescomex irá efetuar a
											consulta no sistema da Duas Rodas.
										</p>
									</div>
								</template>
							</VModal>
						</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group bd-r-0-force mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Data de Digitação</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.diTypingDate" class="form-control" format="DD/MM/YY"
									inputName="diTypingDate" lang="pt-br" name="diTypingDate"
									placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Data de Registro</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.diRegistryDate" class="form-control" format="DD/MM/YY"
									inputName="diRegistryDate" lang="pt-br" name="diRegistryDate"
									placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-l-0-force bd-r-0-force mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Data de Desembaraço</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.diResourcefulnessDate" :disabled="abertaField"
									class="form-control" format="DD/MM/YY" inputName="diResourcefulnessDate"
									lang="pt-br" name="diResourcefulnessDate" placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-t-0-force mg-md-t--1">
						<label class="form-control-label">Canal</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i v-if="model.diChannel === 'VERDE'" class="fa fa-tags tx-success"></i>
								<i v-else-if="model.diChannel === 'AMARELO'" class="fa fa-tags tx-warning"></i>
								<i v-else-if="model.diChannel === 'VERMELHO'" class="fa fa-tags tx-danger"></i>
								<i v-else-if="model.diChannel === 'CINZA'" class="fa fa-tags"></i>
								<i v-else class="fa fa-tags op-5"></i>
							</div>
							<div class="input-group-solved-center">

								<!-- :disabled="isChannelParameterizationLocked" -->
								<select v-model="model.diChannel" class="custom-select form-control wd-100"
									name="diChannel"
									@focus="channelParameterizationPreviousValue = model.diChannel"
									@change="onDiChannelChange">
									<option value></option>
									<option value="VERDE">Verde</option>
									<option value="AMARELO">Amarelo</option>
									<option value="VERMELHO">Vermelho</option>
									<option value="CINZA">Cinza</option>
								</select>
							</div>
							<div class="input-group-solved-after"></div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-r-0-force mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">AFRMM</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-money op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<money v-model="model.integrationAFRMMValue" class="form-control"
									name="integrationAFRMMValue" v-bind="money"></money>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-r-0-force mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Data de pagamento do AFRMM</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.afrmmPaymentDate" class="form-control" format="DD/MM/YY"
									inputName="afrmmPaymentDate" lang="pt-br" name="afrmmPaymentDate"
									placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="isParameterizationChannel(model.diChannel)">
					<div class="form-group bd-r-0-force mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Órgão Anuente</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-building op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<input class="form-control" type="text" v-model="model.consentingAgency"
									name="consentingAgency" :disabled="true" placeholder="" />
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="isParameterizationChannel(model.diChannel)">
					<div class="form-group mg-md-t--1 bd-t-0-force">
						<label class="form-control-label">Data de Parametrização</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.parameterizationDate" :disabled="true"
									class="form-control" format="DD/MM/YY" inputName="parameterizationDate"
									lang="pt-br" name="parameterizationDate" placeholder=""></date-picker>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-gutters" v-if="model.duimp == true">
				<div class="col-md-12">
					<label class="section-title mg-t-10"> Registro Duimp </label>
				</div>
			</div>

			<div class="row no-gutters" v-if="model.duimp == true">
				<div class="col-md-2">
					<div class="form-group mg-md-t--1">
						<label class="form-control-label"> Número do Registro </label>
						<input class="form-control" type="text" v-model="model.duimpIdentification" name="diNumber" v-mask="'##BR##########-#'" placeholder="__BR__________-_"/>
					</div>
				</div>

				<div class="col-md-1">
					<div class="form-group bd-l-0-force mg-md-t--1">
						<label class="form-control-label"> Versão </label>
						<input class="form-control" type="number" v-model="model.duimpVersion" name="duimpVersion" />
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-l-0-force mg-md-t--1 ">
						<label class="form-control-label"> Chave de Acesso </label>
						<input class="form-control" type="text" v-model="model.duimpAccessKey" name="duimpAccessKey" />
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-l-0-force mg-md-t--1">
						<label class="form-control-label"> Data de Digitação </label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker lang="pt-br" v-model="model.duimpTypingDate" name="duimpTypingDate"
									class="form-control" format="DD/MM/YY" placeholder=""></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-l-0-force mg-md-t--1 ">
						<label class="form-control-label"> Data de Registro </label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker lang="pt-br" v-model="model.duimpRegistryDate" name="duimpRegistryDate" inputName="duimpRegistryDate" class="form-control" format="DD/MM/YY"></date-picker>
							</div>
						</div>
					</div>
				</div>
				
				<div class="col-md-3">
					<div class="form-group bd-t-0-force mg-md-t--1 ">
						<label class="form-control-label"> Data de Desembaraço </label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker lang="pt-br" v-model="model.duimpResourcefulnessDate" name="duimpResourcefulnessDate" class="form-control" format="DD/MM/YY" placeholder=""></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="form-group bd-l-0-force bd-t-0-force mg-md-t--1 ">
						<label class="form-control-label"> Canal </label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-tags tx-success" v-if="model.duimpChannel === 'VERDE'"></i>
								<i class="fa fa-tags tx-warning" v-else-if="model.duimpChannel === 'AMARELO'"></i>
								<i class="fa fa-tags tx-danger" v-else-if="model.duimpChannel === 'VERMELHO'"></i>
								<i class="fa fa-tags " v-else-if="model.duimpChannel === 'CINZA'"></i>
								<i class="fa fa-tags op-5" v-else></i>
							</div>
							<div class="input-group ml-1">
								<!-- :disabled="isChannelParameterizationLocked" -->
								<select class="custom-select form-control" v-model="model.duimpChannel"
									name="duimpChannel"
									@focus="channelParameterizationPreviousValue = model.duimpChannel"
									@change="onDuimpChannelChange">
									<option value=""> </option>
									<option value="VERDE"> Verde </option>
									<option value="AMARELO"> Amarelo </option>
									<option value="VERMELHO"> Vermelho </option>
									<option value="CINZA"> Cinza </option>
								</select>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-l-0-force bd-t-0-force mg-md-t--1">
						<label class="form-control-label">AFRMM</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-money op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<money v-model="model.integrationAFRMMValue" class="form-control"
									name="integrationAFRMMValue" v-bind="money"></money>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="model.wayOfTransport == 'MARITIMA'">
					<div class="form-group bd-l-0-force bd-t-0-force mg-md-t--1">
						<label class="form-control-label">Data de pagamento do AFRMM</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.afrmmPaymentDate" class="form-control" format="DD/MM/YY"
									inputName="afrmmPaymentDate" lang="pt-br" name="afrmmPaymentDate"
									placeholder="Selecione"></date-picker>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="isParameterizationChannel(model.duimpChannel)">
					<div class="form-group bd-t-0-force mg-md-t--1">
						<label class="form-control-label">Órgão Anuente</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-building op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<input class="form-control" type="text" v-model="model.consentingAgency"
									name="consentingAgency" :disabled="true" placeholder="" />
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-3" v-if="isParameterizationChannel(model.duimpChannel)">
					<div class="form-group bd-l-0-force bd-t-0-force mg-md-t--1">
						<label class="form-control-label">Data de Parametrização</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker lang="pt-br" v-model="model.parameterizationDate"
									name="parameterizationDate" class="form-control" format="DD/MM/YY"
									:disabled="true" placeholder=""></date-picker>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-12">
					<label class="section-title mg-t-10">Faturamento</label>
				</div>
			</div>

			<div class="row no-gutters">
				<div class="col-md-3">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Período de Armazenagem</label>
						<v-select v-model="model.storagePeriod" :options="storagePeriodsOptions" index="value"
							label="description" name="storagePeriod">
							<template slot="option" slot-scope="option">
								{{ option.description }}
							</template>
							<template slot="no-options"> Não encontrado</template>
						</v-select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">NF Emissão</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center datetime">
								<input
									type="text"
									class="form-control billing-nf-emission-date-input"
									:value="billingNFsEmissionDateDisplay"
									name="billingNFsEmissionDate"
									placeholder="Selecione"
									readonly
									v-validate="'required'"
									@click="openBillingNFsEmissionDateModal"
									:disabled="!model.storagePeriod"
								/>
								<button
									v-if="model.billingNFsEmissionDate && model.storagePeriod"
									type="button"
									class="billing-nf-emission-date-clear"
									@click.stop="handleClearDate"
									title="Limpar"
								>
									<i class="fa fa-times"></i>
								</button>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.billingNFsEmissionDateSolved" name="billingNFsEmissionDateSolved" type="checkbox" :disabled="!model.storagePeriod" />
									<span></span>
								</label>
							</div>
						</div>
						<span class="badge badge-danger" style="white-space: normal;" v-if="!model.storagePeriod">
							{{ "Selecione um Período de Armazenagem" }}
						</span>
					</div>
				</div>

				<div v-if="isCristalMaster" class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1 bg-gray-200">
						<label class="form-control-label tx-danger tx-bold">Número NFe</label>
						<input v-model="model.billingOutgoingNFNumber" class="form-control"
							name="billingOutgoingNFNumber" type="text" />
					</div>
				</div>

				<div v-if="isCristalMaster" class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1 bg-gray-200">
						<label class="form-control-label tx-danger tx-bold">Valor Total NFe</label>
						<money v-model.lazy="model.billingOutgoingNFTotalValue" class="form-control" name="cifValue"
							v-bind="money">
						</money>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-0-force mg-md-t--1">
						<label class="form-control-label">Notas Fiscais</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.billingNFsDate" v-validate="'required'" class="form-control"
									format="DD/MM/YY" inputName="billingNFsDate" lang="pt-br" name="billingNFsDate"
									placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.billingNFsDateSolved" name="billingNFsDateSolved"
										type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group bd-r-1-force mg-md-t--1">
						<label class="form-control-label">Faturamento do Cliente</label>
						<div class="input-group-solved">
							<div class="input-group-solved-before">
								<i class="fa fa-calendar op-5"></i>
							</div>
							<div class="input-group-solved-center">
								<date-picker v-model="model.billingBillCustomerDate" v-validate="'required'"
									class="form-control" format="DD/MM/YY" inputName="billingBillCustomerDate"
									lang="pt-br" name="billingBillCustomerDate" placeholder="Selecione"></date-picker>
							</div>
							<div class="input-group-solved-after">
								<label class="ckbox wd-16 mg-b-0">
									<input v-model="model.billingBillCustomerDateSolved"
										name="billingBillCustomerDateSolved" placeholder="Selecione" type="checkbox" />
									<span></span>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br clear="all" />
		</form>

		<VModal title="Adicionar Cliente" description="" :width="1400" @requestClose="modalContactOpen = false"
			:handler="modalContactOpen">
			<template #content>
				<AddCustomer inModal :redirect="false" @finish="closeCustomerModal" />
			</template>
		</VModal>

		<VModal title="Adicionar Local de Embarque" description="" :width="1000" :height="1" @requestClose="closePlaceOfLoadingModalAndRefreshOptions()"
			:handler="modalPlaceOfLoadingOpen">
			<template #content>
				<AddPlaceOfLoading @finish="closePlaceOfLoadingModal" @cancel="closePlaceOfLoadingModalAndRefreshOptions()" :placeOfLoadingData="placeOfLoading" />
			</template>
		</VModal>

		<VModal title="Adicionar Veículo" description="" :width="1000" :height="1" @requestClose="closeVehicleModalAndRefreshOptions()"
			:handler="modalVehicleOpen">
			<template #content>
				<AddVehicle @finish="closeVehicleModal" @cancel="closeVehicleModalAndRefreshOptions()" :data="vehicle" />
			</template>
		</VModal>

		<VModal
			title="Parametrização de Canal"
			description="Preencha os dados obrigatórios para concluir a parametrização"
			:width="620"
			:height="0"
			classModify="remove-overflow"
			@requestClose="cancelChannelParameterizationModal"
			:handler="modalChannelParameterizationOpen">
			<template #content>
				<div class="channel-parameterization-modal">
					<div
						class="channel-parameterization-banner"
						:class="channelParameterizationBannerClass"
					>
						<i class="fa fa-tags mg-r-10"></i>
						<span>
							Canal selecionado:
							<strong>{{ channelParameterizationChannelLabel }}</strong>
						</span>
					</div>

					<div class="form-group mg-t-20">
						<select-wrapper
							label="Órgão Anuente"
							:required-flag="true"
							:clearable="false"
							:options="licensingAuthorityOptions"
							v-model="channelParameterizationDraft.consentingAgency"
						/>
					</div>

					<div class="form-group mg-b-0">
						<date-wrapper
							label="Data de Parametrização *"
							name="parameterizationDate"
							v-model="channelParameterizationDraft.parameterizationDate"
						/>
					</div>
				</div>
			</template>
			<template #footer>
				<div class="flex ai-c jc-c fgap2">
					<button class="btn btn-secondary" @click.prevent="cancelChannelParameterizationModal">
						Cancelar
					</button>
					<button
						class="crm-button"
						@click.prevent="confirmChannelParameterizationModal"
						:disabled="!isChannelParameterizationDraftValid"
					>
						Confirmar
					</button>
				</div>
			</template>
		</VModal>

		<VModal
			title="NF Emissão"
			description="Selecione a data e o horário"
			:width="480"
			:height="0"
			classModify="remove-overflow"
			@requestClose="cancelBillingNFsEmissionDateModal"
			:handler="modalBillingNFsEmissionDateOpen">
			<template #content>
				<div class="billing-nf-emission-date-modal-fields">
					<div class="form-group billing-nf-emission-date-modal-date-field">
						<label class="form-control-label">Data <span class="text-danger">*</span></label>
						<date-picker
							ref="billingNFsEmissionDateDraftDatePicker"
							v-model="billingNFsEmissionDateDraft.date"
							type="date"
							lang="pt-br"
							format="DD/MM/YYYY"
							:not-before="minDate"
							placeholder="Selecione a data"
							class="w-100 billing-nf-emission-date-picker"
							@change="onBillingNFsEmissionDateDraftDateChange"
						></date-picker>
					</div>
					<div class="form-group mg-b-0 billing-nf-emission-date-modal-time-field">
						<label class="form-control-label">Horário <span class="text-danger">*</span></label>
						<date-picker
							ref="billingNFsEmissionDateDraftTimePicker"
							v-model="billingNFsEmissionDateDraft.time"
							type="time"
							lang="pt-br"
							format="HH:mm"
							:minute-step="1"
							:time-select-options="billingNFsEmissionDateDraftTimeOptions"
							placeholder="Selecione o horário"
							class="w-100 billing-nf-emission-date-picker"
							:disabled="!billingNFsEmissionDateDraft.date"
							@change="onBillingNFsEmissionDateDraftTimeChange"
						></date-picker>
					</div>
				</div>
				<div v-if="billingNFsEmissionDateRequiresShortReason" class="mg-t-20">
					<div class="alert alert-warning mg-b-15">
						<i class="fa fa-exclamation-triangle mg-r-10"></i>
						A data/hora selecionada está a menos de <strong>15 minutos</strong> do momento atual.
						Informe o motivo (mínimo de {{ billingNFsEmissionDateShortReasonMinLength }} caracteres) para prosseguir.
					</div>
					<div class="form-group mg-b-0">
						<label class="form-control-label">Motivo <span class="text-danger">*</span></label>
						<textarea
							v-model="billingNFsEmissionDateShortReason"
							class="form-control"
							rows="3"
							minlength="8"
							placeholder="Informe o motivo pelo prazo reduzido..."
						></textarea>
						<small
							class="form-text text-muted"
							:class="{ 'text-danger': billingNFsEmissionDateShortReason.trim().length > 0 && !isBillingNFsEmissionDateShortReasonValid }"
						>
							{{ billingNFsEmissionDateShortReason.trim().length }}/{{ billingNFsEmissionDateShortReasonMinLength }} caracteres
						</small>
					</div>
				</div>
				<div v-else-if="billingNFsEmissionDateIsNearDeadline" class="mg-t-20">
					<div class="alert alert-warning mg-b-0">
						<i class="fa fa-exclamation-triangle mg-r-10"></i>
						<strong>Alerta!</strong><br />
						O prazo para a emissão da NF está abaixo de uma hora!
					</div>
				</div>
			</template>
			<template #footer>
				<div class="flex ai-c jc-c fgap2">
					<button class="btn btn-secondary" @click.prevent="cancelBillingNFsEmissionDateModal">
						Cancelar
					</button>
					<button
						class="crm-button"
						@click.prevent="saveBillingNFsEmissionDateModal"
						:disabled="billingNFsEmissionDateRequiresShortReason && !isBillingNFsEmissionDateShortReasonValid"
					>
						Salvar
					</button>
				</div>
			</template>
		</VModal>

		<VModal :handler="modalDatesEstimatedGoodsReadinesDate" title="Informações para o Numerário Previsto"
			description="" :width="600" :height="20" @requestClose="closeModalDatesEstimatedGoodsReadinesDate"
			classModify="remove-overflow">
			<template #content>
				<div class="span-12">
					<p class="text-md">
						Quantos dias serão adicionados ao numerário previsto?
					</p>
					<select-wrapper v-show="model.wayOfTransport == 'MARITIMA'" label="Selecione uma opção"
						v-model="modalData.value" :options="modalData.optionsMARITIMA" />
					<select-wrapper v-show="model.wayOfTransport == 'AEREA'" label="Selecione uma opção"
						v-model="modalData.value" :options="modalData.optionsAEREO" />
				</div>
			</template>
			<template #footer>
				<div class="flex ai-c jc-c fgap2">
					<button class="crm-button" @click.prevent="updateEstimatedStepCashRequest">
						Salvar
					</button>
				</div>
			</template>
		</VModal>

		<CustomerTeamsModal
			v-if="model.customer"
			:handler="customerTeamsModalOpen"
			:company-id="model.customer.id"
			:initial-customer="model.customer"
			@requestClose="customerTeamsModalOpen = false"
			@saved="onCustomerTeamsSaved"
		/>
	</div>
</template>

<script>
import Axios from "axios";
import * as constants from "@/consts.js";
import config from "@/config.js";
import { mapState, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import ToggleButton from "vue-js-toggle-button/src/Button.vue";
import { Money } from "v-money";
import vSelect from "vue-select";
import ProcessService from "@/services/ProcessService.js";
import _ from "lodash";
import Swal from "sweetalert2";
import { EventBus } from "@/events/EventBus.js";
import VModal from "@/components/VModal.vue";
import AddCustomer from "@/components/crm/AddCustomer.vue";
import AddPlaceOfLoading from "@/components/crm/AddPlaceOfLoading.vue";
import AddVehicle from "@/components/crm/AddVehicle.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import SelectWrapper from "@/components/SelectWrapper.vue";
import DateWrapper from "@/components/DateWrapper.vue";
import moment from "moment";
import VCheckbox from '@/components/VCheckbox.vue';
import ProcessConferenceSelect from "@/components/processes/ProcessConferenceSelect.vue";
import CustomerTeamsModal from "@/components/crm/CustomerTeamsModal.vue";
import PROCESS_PRIORITY from '@/utils/process/processPriority.js';

export default {
	name: "operational-imp-form-general",
	props: ["data"],
	components: {
		AddCustomer,
		AddPlaceOfLoading,
		DatePicker,
		ToggleButton,
		Money,
		"v-select": vSelect,
		VModal,
		MultiSelect,
		SelectWrapper,
		DateWrapper,
		VCheckbox,
		AddVehicle,
		ProcessConferenceSelect,
		CustomerTeamsModal,
	},
	filters: {
		typeOfProcess(value) {
			const item = constants.LIST_TYPE_OF_PROCESS.find((i) => i.key === value);
			return item ? item.value : value;
		},
	},
	data() {
		return {
			customerTeamsModalOpen: false,
			modalPlaceOfLoadingOpen: false,
			placeOfLoading: {
				name: '',
				type: '',
				codeRfb: '',
				codeIso: '',
				unlocode: '',
				address: {
					state: '',
					city: '',
					countryName: ''
				}
			},
			teamsOptions: [],
			customsTeamOptions: [],
			value: [
					{ name: 'Javascript', code: 'js' }
			],
			optionsTags: [
					{ name: 'Vue.js', code: 'vu' },
					{ name: 'Javascript', code: 'js' },
					{ name: 'Open Source', code: 'os' }
			],
			modalDatesEstimatedGoodsReadinesDate: false,
			priorityReady: false,
			listOfPriority: [
				{
					label: "Nenhuma",
					value: null,
				},
				...PROCESS_PRIORITY,
			],
			modalData: {
				value: null,
				optionsAEREO: [
					{
						label: "Aéreo -  Europa / USA + 7 dias",
						value: 7,
					},
					{
						label: "Aéreo - Asia + 15 dias",
						value: 15,
					},
				],
				optionsMARITIMA: [
					{
						label: "Marítimo Europa / USA + 30 dias",
						value: 30,
					},
					{
						label: "Marítimo - Asia  + 60 dias",
						value: 60,
					},
				],
			},
			money: {
				decimal: ",",
				thousands: ".",
				precision: 2,
				masked: false,
			},
			model: {},
			coinOptions: [],
			initialModel: {},
			listOfIncoterms: constants.OPERATIONAL_INCOTERMS,
			listOfWayOfTransport: constants.OPERATIONAL_WAY_OF_TRANSPORTE,
			listOfTypeOfBoarding: constants.OPERATIONAL_TYPE_OF_BOARDING,
			listOfUseOfGoods: [],
			listOfTypeOfProcess: constants.LIST_TYPE_OF_PROCESS,
			search_accounts: [],
			accountSearchQuery: "",
			di: null,
			abertaField: false,
			isOpenModal: false,
			storagePeriodsOptions: [
				{
					value: "PRIMEIRO_PERIODO",
					description: "Primeiro período",
				},
				{
					value: "SEGUNDO_PERIODO",
					description: "Segundo período",
				},
				{
					value: "TERCEIRO_PERIODO",
					description: "Terceiro período",
				},
				{
					value: "QUARTO_PERIODO",
					description: "Quarto período",
				},
				{
					value: "OUTROS",
					description: "Outros",
				},
			],
			customers: [],
			placeOfLoadingOptions: [],
			vehicleOptions: [],
			priorityTypes: [],
			vehicle: {
				name: '',
                imo: '',
                mmsi: '',
                flag: '',
                type: '',
				entity: '',
			},
			modalVehicleOpen: false,
			modalContactOpen: false,
			timeSelectOptionsKey: 0,
			billingNFsEmissionDateaAddHours: 0,
			modalBillingNFsEmissionDateOpen: false,
			billingNFsEmissionDateDraft: {
				date: null,
				time: null,
			},
			billingNFsEmissionDateShortReason: '',
			billingNFsEmissionDateShortReasonMinLength: 8,
			modalChannelParameterizationOpen: false,
			channelParameterizationField: null,
			channelParameterizationPreviousValue: null,
			channelParameterizationDraft: {
				channel: null,
				consentingAgency: '',
				parameterizationDate: null,
			},
			licensingAuthorityOptions: [],
		};
	},
	methods: {
		isParameterizationChannel(channel) {
			return channel === 'AMARELO' || channel === 'VERMELHO' || channel === 'CINZA';
		},
		resolveConsentingAgencyValue(value) {
			if (value == null) {
				return '';
			}
			if (typeof value === 'object') {
				return String(value.value || value.label || '').trim();
			}
			return String(value).trim();
		},
		async loadLicensingAuthorityOptions() {
			try {
				const response = await Axios.get(`${config.env.API_DEFAULT.host}/licensing-authorities`);
				this.licensingAuthorityOptions = [];
				if (response?.data?.data) {
					this.licensingAuthorityOptions = response.data.data.map((item) => ({
						label: item.acronym + ' - ' + item.name,
						value: item.acronym,
					}));
				}
			} catch (e) {
				this.licensingAuthorityOptions = [];
			}
		},
		onDiChannelChange() {
			this.handleChannelParameterizationChange('diChannel');
		},
		onDuimpChannelChange() {
			this.handleChannelParameterizationChange('duimpChannel');
		},
		async handleChannelParameterizationChange(field) {
			const selected = this.model[field];
			if (!this.isParameterizationChannel(selected)) {
				this.diffObjects(field);
				return;
			}

			if (this.isChannelParameterizationLocked
				|| this.isParameterizationChannel(this.channelParameterizationPreviousValue)) {
				this.model[field] = this.channelParameterizationPreviousValue || '';
				Swal.fire(
					'Parametrização de Canal',
					'Já existe Canal, Órgão Anuente ou Data de Parametrização cadastrados para este processo.',
					'warning'
				);
				return;
			}

			await this.loadLicensingAuthorityOptions();
			this.channelParameterizationField = field;
			this.channelParameterizationDraft = {
				channel: selected,
				consentingAgency: this.model.consentingAgency || '',
				parameterizationDate: this.model.parameterizationDate || null,
			};
			this.model[field] = this.initialModel[field] || null;
			this.modalChannelParameterizationOpen = true;
		},
		cancelChannelParameterizationModal() {
			if (this.channelParameterizationField) {
				this.model[this.channelParameterizationField] = this.channelParameterizationPreviousValue || null;
			}
			this.modalChannelParameterizationOpen = false;
			this.channelParameterizationField = null;
			this.channelParameterizationPreviousValue = null;
			this.channelParameterizationDraft = {
				channel: null,
				consentingAgency: '',
				parameterizationDate: null,
			};
		},
		async confirmChannelParameterizationModal() {
			if (!this.isChannelParameterizationDraftValid || !this.model.id) {
				return;
			}

			const payload = {
				channel: this.channelParameterizationDraft.channel,
				consentingAgency: this.resolveConsentingAgencyValue(this.channelParameterizationDraft.consentingAgency),
				parameterizationDate: moment(this.channelParameterizationDraft.parameterizationDate).format('YYYY-MM-DD'),
			};

			this.$store.commit("setLoading", {
				show: true,
				label: "Parametrização de Canal",
				description: "Registrando parametrização...",
			});

			try {
				const response = await Axios.post(
					`${config.env.API_DEFAULT.host}/process/import/${this.model.id}/channel-parameterization`,
					payload
				);

				if (response.data && response.data.code === 'SUCCESS' && response.data.data) {
					const saved = response.data.data;
					this.model.diChannel = saved.diChannel;
					this.model.duimpChannel = saved.duimpChannel;
					this.model.consentingAgency = saved.consentingAgency;
					this.model.parameterizationDate = saved.parameterizationDate;
	
					const socket = this.$store.state.ProcessStore.socket;
					const processId = this.model.id;
					const websocketFields = {
						diChannel: saved.diChannel,
						duimpChannel: saved.duimpChannel,
						consentingAgency: saved.consentingAgency,
						parameterizationDate: saved.parameterizationDate,
					};
					if (socket && socket.readyState === 1 && processId) {
						Object.keys(websocketFields).forEach((fieldName) => {
							socket.send(
								JSON.stringify({
									action: config.env.WEBSOCKET.actions.UPDATE_PROC,
									data: {
										[processId]: {
											[fieldName]: websocketFields[fieldName],
										},
									},
								})
							);
						});
					}

					this.modalChannelParameterizationOpen = false;
					this.channelParameterizationField = null;
					Swal.fire('Parametrização de Canal', 'Parametrização registrada com sucesso.', 'success');
					setTimeout(() => {
						EventBus.$emit("Operational.imp.Form.Sidebar.Timeline.load");
					}, 500);
				} else {
					Swal.fire(
						'Parametrização de Canal',
						(response.data && response.data.message) || 'Não foi possível registrar a parametrização.',
						'error'
					);
					this.cancelChannelParameterizationModal();
				}
			} catch (error) {
				Swal.fire(
					'Parametrização de Canal',
					(error.response && error.response.data && error.response.data.message)
						|| 'Não foi possível registrar a parametrização.',
					'error'
				);
				this.cancelChannelParameterizationModal();
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		openCustomerTeamsModal() {
			if (this.model && this.model.customer) {
				this.customerTeamsModalOpen = true;
			}
		},
		toTeamId(value) {
			if (value && typeof value === "object" && value.id != null) {
				return value.id;
			}
			return value ?? null;
		},
		onCustomerTeamsSaved(company) {
			if (!company || !this.model.customer) {
				return;
			}
			this.model.customer.hasTypeAccountAndOrder = company.hasTypeAccountAndOrder;
			this.model.customer.hasTypeOrder = company.hasTypeOrder;
			this.model.customer.hasTypeAdvisory = company.hasTypeAdvisory;
			this.model.customer.team = this.toTeamId(company.team);
			this.model.customer.teamOrder = this.toTeamId(company.teamOrder);
			this.model.customer.teamAdvisory = this.toTeamId(company.teamAdvisory);
			this.model.customer.customsTeam = this.toTeamId(company.customsTeam);

			if(this.model.typeOfProcess === "CONTA_E_ORDEM" && !this.model.customer?.team?.id) {
				this.model.team = this.teamsOptions.find(option => option.id === company.team?.id) || null;
			} else if(this.model.typeOfProcess === "ENCOMENDA" && !this.model.customer?.teamOrder?.id) {
				this.model.team = this.teamsOptions.find(option => option.id === company.teamOrder?.id) || null;
			} else if(this.model.typeOfProcess === "ASSESSORIA" && !this.model.customer?.teamAdvisory?.id) {
				this.model.team = this.teamsOptions.find(option => option.id === company.teamAdvisory?.id) || null;
			}

			if ( company.customsTeam?.id) {
				this.model.customsTeam = this.customsTeamOptions.find(option => option.code === company.customsTeam.code) || null;
			}

			this.diffObjects('customsTeam');
		},
		inputAdministrativeTreatmentDone(e) {
			setTimeout(() => {
				this.diffObjects('administrativeTreatmentDone');
			}, 100);
		},
		getTeams() {
			Axios.get(`${config.env.API_DEFAULT.host}/teams`)
			.then((response) => {
				this.teamsOptions = response.data._embedded.teams;
			})
			.catch(async (error) => {
				console.error(error);
			});
		},
		getCustomsTeams() {
			Axios.get(`${config.env.API_DEFAULT.host}/customsTeams`)
			.then((response) => {
				this.customsTeamOptions = response.data._embedded.customsTeams;
			})
			.catch(async (error) => {
				console.error(error);
			});
		},
		closePlaceOfLoadingModalAndRefreshOptions() {
			this.modalPlaceOfLoadingOpen = false;
			this.getPlaceOfLoadingOptions();
			this.placeOfLoading = {
				name: '',
				type: '',
				codeRfb: '',
				codeIso: '',
				unlocode: '',
				address: {
					state: '',
					city: '',
					countryName: ''
				}
			};
		},
		closeVehicleModalAndRefreshOptions() {
			this.modalVehicleOpen = false;
			this.getVehicleOptions();
			this.vehicle = {
				name: '',
				imo: '',
				mmsi: '',
				flag: '',
				type: '',
				entity: '',
			};
		},
		addPlaceOfLoading (placeOfLoading) {
			this.placeOfLoading.name = placeOfLoading;
			this.modalPlaceOfLoadingOpen = true;
		},
		addVehicleTranshipment(vehicleTranshipment) {
			// console.log(vehicleTranshipment);
			this.vehicle.name = vehicleTranshipment;
			this.vehicle.entity = 'vehicleTranshipmentEntity';
			this.modalVehicleOpen = true;
		},
		addVehicle(vehicle) {
			// console.log(vehicle);
			this.vehicle.name = vehicle;
			this.vehicle.entity = 'vehicleEntity';
			this.modalVehicleOpen = true;
		},
		async getPlaceOfLoadingOptions() {
			try {
				const response = await Axios.get(`${config.env.API_DEFAULT.host}/places`);
				this.placeOfLoadingOptions = response.data.data.map((item) => ({
					...item,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/places/${item.id}`,
						},
					},
				}));
			} catch (error) {
				console.error(error);
			}
		},
		async getVehicleOptions() {
			try {
				const response = await Axios.get(`${config.env.API_DEFAULT.host}/vehicles`);
				this.vehicleOptions = response.data.data.map((item) => ({
					...item,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/vehicles/${item.id}`,
						},
					},
				}));
			} catch (error) {
				console.error(error);
			}
		},
		changePriorityTypes(e) {
			if (this.model.priorityTypes && this.model.priorityTypes.length > 0) {
				this.model.priorityTypes = this.model.priorityTypes.map((item) => ({
					...item,
					_links: {
						self: {
							href: item?._links?.self?.href ? item._links.self.href : `${config.env.API_DEFAULT.host}/priority-types/${item.id}`,
						},
					},
				}));
			}
			this.diffObjects('priorityTypes');
		},
		changeProcessUseOfGoods(e) {
			if (this.model.processUseOfGoods && this.model.processUseOfGoods.length > 0) {
				this.model.processUseOfGoods = this.model.processUseOfGoods.map((item) => ({
					...item,
					_links: {
						self: {
							href: item?._links?.self?.href ? item._links.self.href : `${config.env.API_DEFAULT.host}/processUseOfGoods/${item.id}`,
						},
					},
				}));
			}
			this.diffObjects('processUseOfGoods');
		},
		showSalesRadarModal() {
			if(this.model.customer.salesRadarModality === 'LIMITED_50' || this.model.customer.salesRadarModality === 'LIMITED') {
				this.$emit("showSalesRadarModal");
			}
		},
		taxRegimeLabel(regime) {
			const labels = {
				LUCRO_PRESUMIDO: "Lucro Presumido",
				LUCRO_REAL: "Lucro Real",
				SIMPLES: "Simples",
			};
			return labels[regime] || "";
		},
		simplesNacionalStatusLabel(status) {
			if (status === "ATIVO") {
				return "Ativo";
			}
			if (status === "INATIVO") {
				return "Inativo";
			}
			return "Não consultado";
		},
		showTaxRegime() {
			const customer = this.model.customer;
			const regime = customer && customer.taxRegime;
			if (regime !== "SIMPLES") {
				return;
			}
			const status = customer && customer.simplesNacionalStatus;
			const statusColor = status === "ATIVO" ? "#1e7e34" : status === "INATIVO" ? "#c69500" : "#6c757d";
			const statusIcon = status === "ATIVO" ? "fa-check-circle" : status === "INATIVO" ? "fa-exclamation-triangle" : "fa-minus-circle";
			const row = (label, value, extraStyle) => `
				<div style="display:flex; justify-content:space-between; align-items:center; gap:16px; padding:10px 0; border-bottom:1px solid #e9ecef; ${extraStyle || ""}">
					<span style="color:#6c757d; font-size:13px;">${label}</span>
					<strong style="color:#212529; text-align:right;">${value}</strong>
				</div>`;
			let html = `<div style="text-align:left;">${row("Regime fiscal", this.taxRegimeLabel(regime))}`;
			const lastSearch = customer.simplesNacionalStatusLastSearchDate;
			const lastSearchLabel = lastSearch && moment(lastSearch).isValid()
				? moment(lastSearch).format("DD/MM/YYYY")
				: "-";
			const statusValue = `<span style="color:${statusColor};"><i class="fa ${statusIcon}" aria-hidden="true" style="margin-right:6px;"></i>${this.simplesNacionalStatusLabel(status)}</span>`;
			html += row("Status no Simples Nacional", statusValue);
			html += row("Última consulta", lastSearchLabel, "border-bottom:none;");
			html += `</div>`;
			Swal.fire({
				title: "Regime fiscal",
				html,
				confirmButtonText: "Fechar",
				confirmButtonColor: "#395B64",
			});
		},
		async getCustomers() {
			this.$store.commit("setLoading", {
				show: true,
				label: "Carregando...",
				description: "Carregando empresas.",
			});
			try {
				const response = await Axios.get(
					`${config.env.API_DEFAULT.host}/company/findAllCustomers`
				);
				this.customers = response.data.data.map((item) => ({
					...item,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/companies/${item.id}`,
						},
					},
				}));
			} catch (error) {
				Swal.fire({
					title: "Erro ao buscar moedas",
					text: e.response.data.message,
					title: "Listagem de Contatos",
					html: "<p>Não foi possível recuperar os contatos</p>",
					type: "error",
				});
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		async getPriorityTypes() {
			this.$store.commit("setLoading", {
				show: true,
				label: "Carregando...",
				description: "Carregando tipos de prioridade.",
			});
			try {
				const response = await Axios.get(
					`${config.env.API_DEFAULT.host}/newImportProcess/priority-types`
				);
				this.priorityTypes = response.data.data.map((item) => ({
					...item,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/priority-types/${item.id}`,
						},
					},
				}));
			} catch (error) {
				Swal.fire({
					title: "Erro ao buscar tipos de prioridade",
					text: e.response.data.message,
					title: "Tipos de Prioridade",
					html: "<p>Não foi possível recuperar os tipos de prioridade</p>",
					type: "error",
				});
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		async closeCustomerModal(customer = null) {
			if (customer != null) {
				await this.getCustomers();
				this.model.customer = customer;
			}
			this.modalContactOpen = false;
			this.diffObjects("customer");
		},
		clearPlaceOfLoading() {
			this.model.placeOfLoadingEntity = null;
			this.diffObjects("placeOfLoadingEntity");
		},
		clearVehicle() {
			this.model.vehicleEntity = null;
			this.diffObjects("vehicleEntity");
		},
		clearVehicleTranshipment() {
			this.model.vehicleTranshipmentEntity = null;
			this.diffObjects("vehicleTranshipmentEntity");
		},
		async closePlaceOfLoadingModal(placeOfLoading = null) {
			await this.getPlaceOfLoadingOptions();
			if (placeOfLoading != null) {
				this.model.placeOfLoadingEntity = placeOfLoading;
			}
			this.modalPlaceOfLoadingOpen = false;
			this.diffObjects("placeOfLoadingEntity");

			this.placeOfLoading = {
				name: '',
				type: '',
				codeRfb: '',
				codeIso: '',
				unlocode: '',
				address: {
					state: '',
					city: '',
					countryName: ''
				}
			};
		},
		async closeVehicleModal(vehicle = null) {
			await this.getVehicleOptions();

			if (vehicle != null) {
				if (vehicle.entity == 'vehicleEntity') {
					this.model.vehicleEntity = vehicle;
				} else if (vehicle.entity == 'vehicleTranshipmentEntity') {
					this.model.vehicleTranshipmentEntity = vehicle;
				}
				this.diffObjects(vehicle.entity);
			}
			
			this.modalVehicleOpen = false;
			this.vehicle = {
				name: '',
                imo: '',
                mmsi: '',
                flag: '',
                type: '',
				entity: '',
			};
		},
		closeModalDatesEstimatedGoodsReadinesDate() {
			this.modalDatesEstimatedGoodsReadinesDate = false;
			this.modalData.value = null;
		},
		changeWayOfTransport() {
			if (this.model.wayOfTransport !== "MARITIMA") {
				this.model.integrationAFRMMValue = 0;
				this.model.afrmmPaymentDate = null;
			}

			if (!this.model.datesETA) {
				this.modalData.value = null;

				if (this.model.daysToStepCashRequestCalculation) {
					this.updateEstimatedStepCashRequest(false);
				}

				if (
					this.model.wayOfTransport == "MARITIMA" ||
					this.model.wayOfTransport == "AEREA"
				) {
					setTimeout(() => {
						this.modalDatesEstimatedGoodsReadinesDate = true;
					}, 600);
				}
			}
		},

		async updateEstimatedStepCashRequest(closeModal = true) {
			this.$store.commit("setLoading", {
				show: true,
				label: `Numerário Previsto`,
				description: "Atualizando...",
			});
			try {
				this.model.daysToStepCashRequestCalculation = this.modalData.value;
				this.diffObjects("daysToStepCashRequestCalculation");
			} catch (error) {
				console.error(error);

				Swal.fire({
					title: "Erro ao atualizar numerário previsto",
					text: error.response.data.message,
					type: "error",
				});
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});

				if (closeModal) {
					this.closeModalDatesEstimatedGoodsReadinesDate();
				}
			}
		},
		async getCoins() {
			try {
				const response = await Axios.get(
					`${config.env.API_DEFAULT.host}/coins`
				);
				const coins = [
					{
						label: "Sem moeda",
						value: "",
					},
				];

				for (let i = 0; i < response.data._embedded.coins.length; i++) {
					const coin = response.data._embedded.coins[i];
					if (coin.swiftCode) {
						coins.push({
							label: `${coin.swiftCode} - ${coin.name}`,
							value: coin.swiftCode,
						});
					}
				}

				this.coinOptions = coins;
			} catch (e) {
				console.error(e);

				Swal.fire({
					title: "Erro ao buscar moedas",
					text: e.response.data.message,
					type: "error",
				});
			}
		},
		validaIncoterm(e) {
			const value = e.target.value;

			if (
				value == "CIF" &&
				this.model.stepInsuranceValueResponsability == "PRIME"
			) {
				Swal.fire({
					title: "Processo CIF com seguro Prime",
					html: `
            <p>
              Você realmente deseja alterar o incoterm para <b>CIF</b> e manter o responsável pelo seguro como <b>Prime</b>?
            </p>
          `,
					type: "warning",
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: "Marcar como não se aplica",
					confirmButtonAriaLabel: "Marcar como não se aplica",
					cancelButtonText: "Manter o seguro com a Prime",
					cancelButtonAriaLabel: "Manter o seguro com a Prime",
				}).then((response) => {
					if (response.value) {
						this.model.stepInsuranceValueResponsability = "NAO_SE_APLICA";
					}
				});
			}

			this.model.incoterm = value;
		},
		consultarCeMercanteMarinha() {
			const ce = (this.model.ceMercante || "").trim();
			if (!this.model.id) {
				Swal.fire({
					title: "Atenção",
					text: "Salve o processo antes de consultar o CE Mercante.",
					type: "warning",
				});
				return;
			}
			if (!/^\d{15}$/.test(ce)) {
				Swal.fire({
					title: "CE inválido",
					text: "Informe exatamente 15 dígitos.",
					type: "warning",
				});
				return;
			}
			Swal.fire({
				title: "Consultar Marinha Mercante?",
				html:
					"<p>Deseja consultar os dados deste CE na Marinha Mercante?</p>" +
					"<p class=\"text-left mg-t-10\">Se confirmar, <strong>containers</strong> e " +
					"<strong>valores de pagamento / AFRMM</strong> retornados poderão ser preenchidos ou atualizados no processo.</p>",
				type: "question",
				showCancelButton: true,
				confirmButtonText: "Confirmar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (!result.value) {
					return;
				}
				this.$store.commit("setLoading", {
					show: true,
					label: "Consultando CE Mercante",
					description: "Aguarde, consultando dados na Marinha...",
				});
				const base = config.env.API_DEFAULT.host;
				Axios.patch(`${base}/importProcesses/${this.model.id}`, { ceMercante: ce })
					.then(() =>
						Axios.post(`${base}/newImportProcess/${this.model.id}/sync-ce-mercante`)
					)
					.then((res) => {
						if (res.data && res.data.data) {
							const data = res.data.data;
							this.model.integrationAFRMMValue = data.integrationAFRMMValue ?? 0;
							this.model.afrmmPaymentDate = this.parseApiDateOnlyToLocalDate( data.afrmmPaymentDate ?? null);

							this.initialModel.integrationAFRMMValue = this.model.integrationAFRMMValue;
							this.initialModel.afrmmPaymentDate = this.model.afrmmPaymentDate;

							const socket = this.$store.state.ProcessStore.socket;
							const processId = this.model.id;
							const websocketFields = {
								integrationAFRMMValue: this.model.integrationAFRMMValue,
								afrmmPaymentDate: this.model.afrmmPaymentDate,
							};
							if (socket && socket.readyState === 1 && processId) {
								Object.keys(websocketFields).forEach((fieldName) => {
									socket.send(
										JSON.stringify({
											action: config.env.WEBSOCKET.actions.UPDATE_PROC,
											data: {
												[processId]: {
													[fieldName]: websocketFields[fieldName],
												},
											},
										})
									);
								});
							}
						}
						Swal.fire({
							title: "Sucesso",
							text: (res.data && res.data.message) || "Consulta concluída.",
							type: "success",
						});
					})
					.catch((e) => {
						const msg =
							e.response && e.response.data && e.response.data.message
								? e.response.data.message
								: e.message;
						Swal.fire("Erro", msg, "error");
					})
					.finally(() => {
						this.$store.commit("setLoading", { show: false });
					});
			});
		},
		normalizeCeMercanteChecked(value) {
			if (value === true || value === "true") {
				return true;
			}
			if (value === false || value === "false") {
				return false;
			}
			return null;
		},
		/** Evita deslocar um dia no fuso local (ex.: API "2026-07-29" → Date UTC meia-noite → 28/07 no BR). */
		parseApiDateOnlyToLocalDate(value) {
			if (value === null || value === undefined || value === "") return null;
			if (value instanceof Date) return value;
			if (typeof value === "string") {
				const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
				if (m) {
					const y = parseInt(m[1], 10);
					const month = parseInt(m[2], 10) - 1;
					const d = parseInt(m[3], 10);
					return new Date(y, month, d);
				}
			}
			return value;
		},
		setCeMercanteConference(value) {
			if (this.abertaField) {
				return;
			}
			const next = this.normalizeCeMercanteChecked(value);
			const cur = this.normalizeCeMercanteChecked(this.model.ceMercanteChecked);
			if (cur === next) {
				return;
			}
			this.$set(this.model, "ceMercanteChecked", next);
			this.diffObjects("ceMercanteChecked");
		},
		validaResponsavelSeguro(e) {
			const value = e.target.value;

			Swal.fire({
				title: "Responsável pelo seguro",
				html: `
            <p>
              Você realmente deseja alterar o <b>responsável pelo seguro</b>?
            </p>
          `,
				type: "warning",
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: "Sim, tenho certeza",
				confirmButtonAriaLabel: "Sim, tenho certeza",
				cancelButtonText: "Não, cancelar",
				cancelButtonAriaLabel: "Não, cancelar",
			}).then((response) => {
				if (response.value) {
					this.model.stepInsuranceValueResponsability = value;
				} else {
					e.target.value = this.model.stepInsuranceValueResponsability;
				}
			});
		},
		...mapActions("ProcessStore", ["verifyRadarIsChecked"]),
		changeTypeOfProcess() {
			if (this.model.typeOfProcess != null && this.model.typeOfProcess != "") {
				Swal.fire({
					title: "Tipo de Processo",
					html: "Você realmente deseja alterar o <b>Tipo de Processo</b>?",
					type: "warning",
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim, alterar!',
					confirmButtonAriaLabel: "Sim, alterar!",
					cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
					cancelButtonAriaLabel: "Cancelar",
				}).then((result) => {
					this.$store.commit("setLoading", {
						show: true,
						label: "Alterando tipo de processo",
						description:
							"Aguarde, estamos alterando a ordem das referências...",
					});

					if (result.value) {
						Axios.put(
							config.env.API_DEFAULT.host +
							`/newImportProcess/change-type-of-process/${this.model.id}/${this.model.typeOfProcess}`
						)
							.then((response) => {
								this.model = response.data.data;
								this.$store.commit(
									"ProcessStore/SET_ACTIVE",
									response.data.data
								);
								this.$store.commit(
									"ProcessStore/SET_SINGLE_PROCESS",
									response.data.data
								);
								Swal.fire(
									"Tipo de Processo",
									"O Tipo deste Processo foi alterado com sucesso <i class'fa fa-thumbs-up'></i> ",
									"success"
								);
							})
							.catch((error) => {
								Swal.fire(
									"Não foi possível atualizar",
									error.response.data.message,
									"error"
								);
							});
					} else {
						this.model.typeOfProcess = this.initialModel.typeOfProcess;
					}

					this.$store.commit("setLoading", {
						show: false,
					});
				});
			}
		},
		changeIdentification() {
			var self = this;
			var oldIdentification = self.model.identification;

			Swal.fire({
				title: "Referência Interna",
				html:
					"Você realmente deseja alterar a referência interna <br /> atual deste processo? A referência atual é <b>" +
					self.model.identification +
					"</b>.",
				type: "warning",
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim, alterar!',
				confirmButtonAriaLabel: "Sim, alterar!",
				cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
				cancelButtonAriaLabel: "Cancelar",
			}).then((result) => {
				if (result.value) {
					Swal.fire({
						type: "info",
						title: "Nova Referência Interna",
						text: "Digite a nova referência interna deste processo:",
						input: "number",
						inputAttributes: {
							autocapitalize: "on",
						},
						showCloseButton: true,
						showCancelButton: true,
						confirmButtonColor: "##23BF08",
						cancelButtonColor: "#dc3545",
						confirmButtonText: "Confirmar",
						cancelButtonText: "Cancelar",
						showLoaderOnConfirm: true,
						preConfirm: (referencia) => {
							self.model.identification = referencia;

							return ProcessService.verifyIfIdentificationExists(
								self.model.id,
								referencia,
								self.model.typeOfProcess
									? self.model.typeOfProcess
									: "CONTA_E_ORDEM"
							)
								.then((r) => {
									if (r.data.data === false) {
										Axios.put(
											config.env.API_DEFAULT.host +
											`/newImportProcess/change-manual-identification/${self.model.id}/${referencia}`
										).then((res) => {
											this.$store.commit(
												"ProcessStore/SET_ACTIVE",
												res.data.data
											);
											this.$store.commit(
												"ProcessStore/SET_SINGLE_PROCESS",
												res.data.data
											);
										});

										const response = this.$store.dispatch(
											"ProcessStore/diffObjects",
											{
												initialModel: self.initialModel,
												model: self.model,
												fieldName: "identification",
											}
										);

										if (response) {
											self.initialModel = { ...self.model };
										}
									} else {
										self.model.identification = oldIdentification;
										Swal.fire(
											"Referência Interna em Uso",
											"A referência " +
											referencia +
											" já está em uso por outro processo.",
											"error"
										);
										Swal.fire({
											type: "error",
											title: "Referência Interna em Uso",
											html:
												"A Referência Interna deste processo não pode ser alterada!<br />Já existe um processo com a Referência Interna <b>" +
												referencia +
												"</b>.",
											showCloseButton: true,
										});
										return false;
									}
								})
								.catch((e) => {
									self.model.identification = oldIdentification;
									Swal.fire(
										"Salvar",
										"Não foi possível salvar o processo: " + e,
										"error"
									);
									return false;
								});
						},
						allowOutsideClick: () => !Swal.isLoading(),
					}).then((result) => {
						if (result.value) {
							Swal.fire({
								type: "success",
								title: "Nova Referência Interna",
								html:
									"A Referência Interna deste processo foi<br/> alterada com sucesso de <b>" +
									oldIdentification +
									"</b> para <b>" +
									self.model.identification +
									"</b>.",
								showCloseButton: true,
							});
						}
					});
				}
			});
		},
		generateNewIdentification() {
			let self = this;
			Axios.get(
				config.env.API_DEFAULT.host +
				"/process/import/generateNewIdentification"
			)
				.then((r) => {
					self.model.identification = r.data.data.next;

					var step = null;

					if (this.steps !== null && this.steps !== undefined) {
						step = this.steps.filter((step) => {
							return step.first;
						});

						if (
							step[0] !== null &&
							step[0] !== undefined &&
							step[0]._links !== undefined &&
							step[0]._links.self !== undefined
						) {
							this.model.step = step[0]._links.self.href;
							this.diffObjects("identification");
						} else {
							Swal.fire(
								"Processo de Importação",
								"Verifique as configurações das etapas e certifique-se de que existe uma etapa configurada como etapa inicial. <small>(É necessário ter uma etapa inicial configurada para que o processo seja aberto)</small>",
								"error"
							);
						}
					}
				})
				.catch((e) => {
					Swal.fire(
						"Referência Interna",
						"Não foi possível gerar uma Referência Interna para este processo.",
						"error"
					);
				});
		},
		getCompanies: _.debounce(function (search) {
			this.$store
				.dispatch("ProcessStore/getCompanies", search)
				.then((response) => { })
				.catch((error) => {
					Swal.fire(
						"Empresas",
						"Ops, houve algum erro no carregamento das empresas! ",
						"error"
					);
				});
		}, 500),
		getCustomersBrokers: _.debounce(function (search) {
			this.$store
				.dispatch("ProcessStore/getCustomersBrokers", search)
				.then((response) => { })
				.catch((error) => {
					Swal.fire(
						"Empresas",
						"Ops, houve algum erro no carregamento das empresas! " + error,
						"error"
					);
				});
		}, 500),
		getForwarders: _.debounce(function (search) {
			this.$store
				.dispatch("ProcessStore/getForwarders", search)
				.then((response) => { })
				.catch((error) => {
					Swal.fire(
						"Empresas",
						"Ops, houve algum erro no carregamento das empresas! ",
						"error"
					);
				});
		}, 500),
		getShipowners: _.debounce(function (search) {
			this.$store
				.dispatch("ProcessStore/getShipowners", search)
				.then((response) => { })
				.catch((error) => {
					Swal.fire(
						"Empresas",
						"Ops, houve algum erro no carregamento das empresas! ",
						"error"
					);
				});
		}, 500),
		getExporters: _.debounce(function (search) {
			this.$store
				.dispatch("ProcessStore/getExporters", search)
				.then((response) => { })
				.catch((error) => {
					Swal.fire(
						"Exportadores / Fabricantes",
						"Ops, houve algum erro no carregamento das empresas! ",
						"error"
					);
				});
		}, 500),
		getCustomsEnclosures: _.debounce(async function (search) {
			this.$store
				.dispatch("ProcessStore/getCustomsEnclosures", search)
				.then((response) => {
					// this.listOfRecintosAlfandegados = response;
					// this.$set(this, "listOfRecintosAlfandegados", response);
				})
				.catch((error) => {
					Swal.fire(
						"Recintos Alfandegados",
						"Ops, houve algum erro no carregamento das informações! " + error,
						"error"
					);
				});
		}, 500),
		onAccountSearchEmitted(search) {
			this.accountSearchQuery = search == null || search === "" ? "" : String(search);
		},
		syncAccountSearchQueryFromSelect() {
			this.$nextTick(() => {
				const sel = this.$refs.accountSelect;
				const q = sel && sel.search != null ? sel.search : "";
				this.accountSearchQuery = String(q);
			});
		},
		getAccounts: function (search, loading) {
			loading(true);
			Axios.get(
				config.env.API_DEFAULT.host +
				"/accounts/search/findAllByNameContainingIgnoreCase?name=" +
				search
			)
				.then((response) => {
					this.search_accounts = response.data._embedded.accounts;
					loading(false);
				})
				.catch(function (error) {
					swal(
						"Não foi possível carregar a listagem de Filiais disponíveis: " +
						error,
						"error"
					);
				});
		},
		// Nome do campo para diff no blur do #generalForm (fallbacks sequenciais; evita depender só de attributes[1] + type).
		resolveGeneralFormBlurFieldName(e, el) {
			const trimStr = (v) => (v == null ? "" : String(v).trim());

			let field = trimStr(el.name);
			if (field) {
				return field;
			}

			const attrs = el.attributes;
			if (attrs) {
				const nameAttr = attrs.getNamedItem("name");
				if (nameAttr && nameAttr.value != null) {
					field = trimStr(nameAttr.value);
					if (field) {
						return field;
					}
				}
			}

			let path = [];
			if (typeof e.composedPath === "function") {
				try {
					path = e.composedPath() || [];
				} catch (_err) {
					path = [];
				}
			}
			if (!path.length) {
				path = e.path || [];
			}

			for (let i = 0; i < path.length; i++) {
				const node = path[i];
				if (!node || node.nodeType !== 1) {
					continue;
				}
				field = trimStr(node.name);
				if (field) {
					return field;
				}
				const nodeAttrs = node.attributes;
				if (!nodeAttrs) {
					continue;
				}
				const na = nodeAttrs.getNamedItem("name");
				if (na && na.value != null) {
					field = trimStr(na.value);
					if (field) {
						return field;
					}
				}
			}

			if (!attrs || attrs.length === 0) {
				return null;
			}

			const attr1 = attrs.length > 1 ? attrs[1] : null;
			if (attr1 && attr1.name === "type") {
				return null;
			}
			if (attr1 && attr1.value != null) {
				field = trimStr(attr1.value);
				if (field) {
					return field;
				}
			}

			return null;
		},
		async diffObjects(fieldName) {
			if (
				this.model.id !== null &&
				this.model.id !== undefined &&
				this.model.identification !== null &&
				this.model.identification !== undefined &&
				this.model.typeOfProcess !== null &&
				this.model.typeOfProcess !== undefined
			) {
				await ProcessService.verifyIfIdentificationExists(
					this.model.id,
					this.model.identification,
					this.model.typeOfProcess
				)
					.then((r) => {
						var identification = this.model.identification;

						if (r.data.data === false) {

							// Se o campo account for null ou undefined, seta o valor do initialModel
							if (!this.model?.account) {
								this.model.account = this.initialModel.account;
							}

							const response = this.$store.dispatch(
								"ProcessStore/diffObjects",
								{
									initialModel: this.initialModel,
									model: this.model,
									fieldName: fieldName,
								}
							);

							if (response) {
								this.initialModel = { ...this.model };
							}
						} else {
							if (
								this.initialModel !== null &&
								this.initialModel !== undefined
							) {
								this.model.identification = this.initialModel.identification;
							} else {
								this.model.identification = "";
							}

							Swal.fire(
								"Referência Interna em Uso",
								"A referência " +
								identification +
								" já está em uso por outro processo.",
								"error"
							);
						}
					})
					.catch((e) => {
						this.$store.commit("setLoading", { show: false });
						Swal.fire(
							"Salvar",
							"Não foi possível salvar o processo: " + e,
							"error"
						);
					});
			} else if (
				(this.model.id === null || this.model.id === undefined) &&
				this.model.identification !== null &&
				this.model.identification !== undefined
			) {
				this.$store.commit("setLoading", { show: true });
				this.model.step = config.env.API_DEFAULT.host + "/processSteps/7";
				const response = await this.$store.dispatch(
					"ProcessStore/postImportProcess",
					{
						model: this.model,
					}
				);

				if (response) {
					this.initialModel = {
						...this.model,
					};

					if (response?.error !== null) {
						let message = '';
						message += "<div>";
						message += `<h4 class="mb-4 mt-2 text-left">O processo foi salvo sob a referência interna de nº ${this.model.identification}.</h4>`;
						message += `<p class="text-left">Porém, ocorreu um erro ao criar as tarefas no Jira: ${response?.error}</p>`;
						message += "</div>";
						Swal.fire({
							title: "Novo Processo de Importação",
							html: message,
							type: "warning",
						});
					} else {
						let message = '';
						message += "<div>";
						message += `<h4 class="mb-4 mt-2 text-left">O processo foi salvo sob a referência interna de nº ${this.model.identification}.</h4>`;
						message += `<p class="text-left">As tarefas do processo foram criadas no Jira:</p>`;
						message += `<ul class="list-group">`;
						for (let i = 0; i < response?.jiraTasks.length; i++) {
							message += `<li class="list-group-item flex ai-c jc-sb fgap2">${response?.jiraTasks[i].label} - ${response?.jiraTasks[i].taskKey ? response?.jiraTasks[i].taskKey : "Não foi possível criar"}</li>`;
						}
						message += `</ul>`;
						message += "</div>";
						Swal.fire({
							title: "Novo Processo de Importação",
							html: message,
							type: "success",
						});
					}

					this.model.id = this.process.id;
					this.model.identification = this.process.identification;
					this.$store.commit("setLoading", { show: false });
				}
			}
		},
		openModal() {
			this.isOpenModal = true;
		},
		closeModal() {
			this.isOpenModal = false;
		},
		getBillingNFsEmissionMinDateTime() {
			return moment().add(this.billingNFsEmissionDateaAddHours, "hour");
		},
		truncateBillingNFsEmissionDateToMinute(date) {
			return moment(date).second(0).millisecond(0);
		},
		openBillingNFsEmissionDateModal() {
			if (!this.model.storagePeriod) {
				return;
			}

			const current = this.model.billingNFsEmissionDate
				? moment(this.model.billingNFsEmissionDate)
				: null;

			this.billingNFsEmissionDateDraft = {
				date: current ? current.clone().startOf("day").toDate() : null,
				time: current ? current.clone().second(0).millisecond(0).toDate() : null,
			};
			this.billingNFsEmissionDateShortReason = "";
			this.timeSelectOptionsKey++;
			this.modalBillingNFsEmissionDateOpen = true;
		},
		cancelBillingNFsEmissionDateModal() {
			this.modalBillingNFsEmissionDateOpen = false;
			this.billingNFsEmissionDateShortReason = "";
		},
		onBillingNFsEmissionDateDraftDateChange() {
			this.timeSelectOptionsKey++;
			this.closeBillingNFsEmissionDateDraftPicker("billingNFsEmissionDateDraftDatePicker");

			if (!this.billingNFsEmissionDateDraft.date) {
				this.billingNFsEmissionDateDraft.time = null;
				return;
			}

			this.normalizeBillingNFsEmissionDateDraftTime();
		},
		onBillingNFsEmissionDateDraftTimeChange() {
			this.timeSelectOptionsKey++;
			this.closeBillingNFsEmissionDateDraftPicker("billingNFsEmissionDateDraftTimePicker");
			this.normalizeBillingNFsEmissionDateDraftTime();
		},
		closeBillingNFsEmissionDateDraftPicker(refName) {
			const picker = this.$refs[refName];

			if (picker && typeof picker.closePopup === "function") {
				picker.closePopup();
			}
		},
		normalizeBillingNFsEmissionDateDraftTime() {
			if (!this.billingNFsEmissionDateDraft.time) {
				return;
			}

			const opts = this.billingNFsEmissionDateDraftTimeOptions;
			const selected = moment(this.billingNFsEmissionDateDraft.time);
			let hour = selected.hour();
			let minute = selected.minute();

			if (!opts.hours.includes(hour)) {
				hour = opts.hours.length ? opts.hours[0] : null;
			}

			if (hour === null) {
				this.billingNFsEmissionDateDraft.time = null;
				return;
			}

			if (!opts.minutes.includes(minute)) {
				minute = opts.minutes.length ? opts.minutes[0] : 0;
			}

			this.billingNFsEmissionDateDraft.time = moment(this.billingNFsEmissionDateDraft.time)
				.hour(hour)
				.minute(minute)
				.second(0)
				.millisecond(0)
				.toDate();

			const built = this.buildBillingNFsEmissionDateFromDraft();
			const minDateTime = this.truncateBillingNFsEmissionDateToMinute(
				this.getBillingNFsEmissionMinDateTime()
			);

			if (built && this.truncateBillingNFsEmissionDateToMinute(built).isBefore(minDateTime)) {
				this.billingNFsEmissionDateDraft.time = minDateTime.toDate();
			}
		},
		buildBillingNFsEmissionDateFromDraft() {
			const { date, time } = this.billingNFsEmissionDateDraft;

			if (!date || !time) {
				return null;
			}

			const timeMoment = moment(time);

			return moment(date)
				.hour(timeMoment.hour())
				.minute(timeMoment.minute())
				.second(0)
				.millisecond(0)
				.toDate();
		},
		applyBillingNFsEmissionDate(date) {
			this.model.billingNFsEmissionDate = date;
			setTimeout(() => {
				this.diffObjects("billingNFsEmissionDate");
			}, 200);
		},
		async saveBillingNFsEmissionDateModal() {
			const built = this.buildBillingNFsEmissionDateFromDraft();

			if (!built) {
				Swal.fire(
					"NF Emissão",
					"Selecione a data e o horário.",
					"warning"
				);
				return;
			}

			let selectedDate = moment(built);
			const minDateTime = this.truncateBillingNFsEmissionDateToMinute(
				this.getBillingNFsEmissionMinDateTime()
			);

			if (this.truncateBillingNFsEmissionDateToMinute(selectedDate).isBefore(minDateTime)) {
				Swal.fire(
					"NF Emissão",
					"O horário deve ser igual ou posterior ao horário atual.",
					"warning"
				);
				return;
			}

			const minAllowed = moment().add(15, "minutes");
			const requiresShortReason = selectedDate.isBefore(minAllowed);
			const shortReason = (this.billingNFsEmissionDateShortReason || "").trim();

			if (requiresShortReason && !shortReason) {
				Swal.fire(
					"NF Emissão",
					"Informe o motivo pelo prazo reduzido.",
					"warning"
				);
				return;
			}

			if (
				requiresShortReason &&
				shortReason.length < this.billingNFsEmissionDateShortReasonMinLength
			) {
				Swal.fire(
					"NF Emissão",
					`O motivo deve ter no mínimo ${this.billingNFsEmissionDateShortReasonMinLength} caracteres.`,
					"warning"
				);
				return;
			}

			if (requiresShortReason) {
				const formattedDate = selectedDate.format("DD/MM/YY HH:mm");

				try {
					this.$store.commit("setLoading", {
						show: true,
						label: "NF Emissão",
						description: "Salvando motivo do prazo reduzido...",
					});

					await Axios.post(
						`${config.env.API_DEFAULT.host}/history/process/${this.model.id}/save`,
						{
							description: `NF Emissão (prazo reduzido - ${formattedDate}): ${shortReason}`,
							isVisibleToClient: false,
							processType: "IMPORT",
							stepDescription: this.process?.step?.description || null,
							type: "NF_EMISSION_DATE_SHORT_REASON",
							priority: "URGENTE",
						}
					);
				} catch (e) {
					this.$store.commit("setLoading", { show: false });

					Swal.fire(
						"NF Emissão",
						"Erro ao tentar salvar histórico de NF Emissão",
						"error"
					);
					return;
				}

				this.$store.commit("setLoading", { show: false });
			}

			this.applyBillingNFsEmissionDate(selectedDate.toDate());
			this.billingNFsEmissionDateShortReason = "";
			this.modalBillingNFsEmissionDateOpen = false;

			if (requiresShortReason) {
				setTimeout(() => {
					EventBus.$emit("Operational.imp.Form.Sidebar.Timeline.load");
				}, 500);
			}
		},
		handleClearDate() {
			this.model.billingNFsEmissionDate = null;
			this.billingNFsEmissionDateShortReason = "";
			setTimeout(() => {
				this.diffObjects("billingNFsEmissionDate");
			}, 200);
		},
		async getListOfUseOfGoods() {
			this.$store.commit("setLoading", {
				show: true,
				label: "Carregando...",
				description: "Carregando destinação de mercadorias.",
			});
			try {
				const response = await Axios.get(`${config.env.API_DEFAULT.host}/processUseOfGoods`);
				if (response?.data?._embedded?.processUseOfGoods) {
					this.listOfUseOfGoods = response.data._embedded.processUseOfGoods.map((item) => ({
						...item,
						_links: {
							self: {
								href: item._links.self.href,
							},
						},
					}));
				}
			} catch (error) {
				console.error(error);
				Swal.fire({
					title: "Erro ao buscar destinação de mercadorias",
					text: error.response.data.message,
					title: "Destinação de Mercadorias",
					html: "<p>Não foi possível recuperar as destinações de mercadorias</p>",
					type: "error",
				});
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
	},
	computed: {
		...mapState("ProcessStore", [
			"hasTFADocument",
			"accounts",
			"steps",
			"optionsCompanies",
			"optionsCustomers",
			"optionsExporters",
			"optionsCustomersBrokers",
			"optionsForwarders",
			"optionsShipowners",
			"optionsReceitaFederalUnits",
			"optionsCustomsEnclosures",
			"listOfURFs",
		]),
		...mapState({
			process: (state) => state.ProcessStore.activeProcess,
			StateNoClick: (state) => state.ProcessStore.noClick,
		}),
		isChannelParameterizationLocked() {
			return !!(
				(this.model.consentingAgency && String(this.model.consentingAgency).trim())
				|| this.model.parameterizationDate
			);
		},
		isChannelParameterizationDraftValid() {
			const agency = this.resolveConsentingAgencyValue(this.channelParameterizationDraft.consentingAgency);
			return !!(agency && this.channelParameterizationDraft.parameterizationDate && this.channelParameterizationDraft.channel);
		},
		channelParameterizationChannelLabel() {
			const channel = this.channelParameterizationDraft.channel;
			if (channel === 'AMARELO') return 'Amarelo';
			if (channel === 'VERMELHO') return 'Vermelho';
			if (channel === 'CINZA') return 'Cinza';
			if (channel === 'VERDE') return 'Verde';
			return channel || '';
		},
		channelParameterizationBannerClass() {
			const channel = this.channelParameterizationDraft.channel;
			if (channel === 'AMARELO') return 'channel-parameterization-banner--amarelo';
			if (channel === 'VERMELHO') return 'channel-parameterization-banner--vermelho';
			if (channel === 'CINZA') return 'channel-parameterization-banner--cinza';
			return '';
		},
		minDate() {
			return moment().add(this.billingNFsEmissionDateaAddHours, 'hour').toDate();
		},
		hasWithoutOperationalTeamAlert() {
			// if (this.model.team) {
				if (
					(this.model.typeOfProcess === "CONTA_E_ORDEM" &&
						this.model.customer.team === null) ||
					(this.model.typeOfProcess === "ENCOMENDA" &&
						this.model.customer.teamOrder === null) ||
					(this.model.typeOfProcess === "ASSESSORIA" &&
						this.model.customer.teamAdvisory === null)
				) {
					return true;
				}
			// }

			return false;
		},
		hasWithoutCustomsTeamAlert() {
			return this.model?.customer?.customsTeam === null || this.model?.customer?.customsTeam === undefined;
		},
		isCristalMaster() {
			if (
				this.model !== undefined &&
				this.model !== null &&
				this.model.customer !== undefined &&
				this.model.customer !== null
			) {
				return (
					this.model.customer.id == 24 ||
					this.model.customer.federalID === "05.378.317/0001-80"
				);
			}

			return false;
		},
		ceMercanteValid() {
			const ce = (this.model.ceMercante || "").trim();
			return /^\d{15}$/.test(ce);
		},
		options() {
			return [
				"blur",
				(e) => {
					const el = e.target || e.srcElement;
					if (!el || el.nodeType !== 1) {
						return false;
					}
					if (el.name === "identification" || el.name === "billingNFsEmissionDate") {
						return false;
					}

					const fieldName = this.resolveGeneralFormBlurFieldName(e, el);
					if (!fieldName) {
						return false;
					}

					setTimeout(() => {
						this.diffObjects(fieldName);
					}, 200);
				},
				true,
			];
		},
		invoiceInconsistence() {
			let installmentsTotal = 0;

			if (this.model.invoices && this.model.invoices.length > 0) {
				this.model.invoices.forEach((invoice) => {
					installmentsTotal += invoice.installments.reduce(
						(cur, acc) => (cur += acc.value),
						0
					);
				});
			}

			installmentsTotal = Math.round(parseFloat(installmentsTotal) * 100) / 100;

			if (this.model.invoiceTotal > installmentsTotal) {
				return "Valor MAIOR que o Valor Total das Invoices";
			} else if (this.model.invoiceTotal < installmentsTotal) {
				return "Valor MENOR que o Valor Total das Invoices";
			}

			return null;
		},
		billingNFsEmissionDateDisplay() {
			if (!this.model.billingNFsEmissionDate) {
				return "";
			}

			return moment(this.model.billingNFsEmissionDate).format("DD/MM/YY HH:mm");
		},
		billingNFsEmissionDateRequiresShortReason() {
			const built = this.buildBillingNFsEmissionDateFromDraft();

			if (!built) {
				return false;
			}

			const selectedDate = moment(built);
			const minDateTime = this.truncateBillingNFsEmissionDateToMinute(
				this.getBillingNFsEmissionMinDateTime()
			);

			if (this.truncateBillingNFsEmissionDateToMinute(selectedDate).isBefore(minDateTime)) {
				return false;
			}

			return this.truncateBillingNFsEmissionDateToMinute(selectedDate).isBefore(
				this.truncateBillingNFsEmissionDateToMinute(moment().add(15, "minutes"))
			);
		},
		billingNFsEmissionDateIsNearDeadline() {
			const built = this.buildBillingNFsEmissionDateFromDraft();

			if (!built) {
				return false;
			}

			const selectedDate = moment(built);
			const minDateTime = this.truncateBillingNFsEmissionDateToMinute(
				this.getBillingNFsEmissionMinDateTime()
			);

			if (this.truncateBillingNFsEmissionDateToMinute(selectedDate).isBefore(minDateTime)) {
				return false;
			}

			if (this.billingNFsEmissionDateRequiresShortReason) {
				return false;
			}

			return this.truncateBillingNFsEmissionDateToMinute(selectedDate).isBefore(
				this.truncateBillingNFsEmissionDateToMinute(moment().add(1, "hour"))
			);
		},
		isBillingNFsEmissionDateShortReasonValid() {
			return (
				(this.billingNFsEmissionDateShortReason || "").trim().length >=
				this.billingNFsEmissionDateShortReasonMinLength
			);
		},
		billingNFsEmissionDateDraftTimeOptions() {
			const _ = this.timeSelectOptionsKey;
			const minDateTime = this.getBillingNFsEmissionMinDateTime();
			const draftDate = this.billingNFsEmissionDateDraft.date
				? moment(this.billingNFsEmissionDateDraft.date).startOf("day")
				: null;
			const selectedHour = this.billingNFsEmissionDateDraft.time
				? moment(this.billingNFsEmissionDateDraft.time).hour()
				: null;

			let minHour = minDateTime.hour();

			if (draftDate) {
				if (draftDate.isSame(minDateTime, "day")) {
					minHour = minDateTime.hour();
				} else {
					minHour = 0;
				}
			}

			const hours = [];
			for (let h = minHour; h <= 23; h++) {
				hours.push(h);
			}

			let startMinute = 0;
			if (draftDate && draftDate.isSame(minDateTime, "day") && selectedHour === minDateTime.hour()) {
				startMinute = minDateTime.minute();
			} else if (!draftDate) {
				startMinute = minDateTime.minute();
			}

			const minutes = [];
			for (let m = startMinute; m <= 59; m++) {
				minutes.push(m);
			}

			return {
				hours: [...hours],
				minutes: [...minutes],
			};
		},
	},

	async mounted() {
		this.getCustomers();
		this.getPlaceOfLoadingOptions();
		this.getTeams();
		this.getCustomsTeams();
		this.getVehicleOptions();
		this.getCoins();
		this.getPriorityTypes();
		this.getListOfUseOfGoods();

		if (window.addEventListener) {
			setTimeout(() => {
				const form = document.getElementById("generalForm");
				if (form !== null) {
					form.addEventListener(...this.options);
				}
			}, 200);
		}

		if (this.process) {
			this.model = {
				...this.process,
				afrmmPaymentDate: this.parseApiDateOnlyToLocalDate(
					this.process.afrmmPaymentDate ?? null
				),
				integrationAFRMMValue: this.process.integrationAFRMMValue ?? 0,
			};
			this.$set(
				this.model,
				"ceMercanteChecked",
				this.normalizeCeMercanteChecked(this.model.ceMercanteChecked)
			);

			this.initialModel = {
				...this.model,
			};

			this.priorityReady = !!this.model.priority;

			if (this.model.id === null || this.model.identification === null) {
				this.generateNewIdentification();
			}

			if (
				this.model.customer !== undefined &&
				this.model.customer !== null &&
				this.model.customer.id !== null
			) {
				await this.verifyRadarIsChecked();
			} else {
				await this.$store.dispatch("ProcessStore/checkHasTFADocumentDatesGoodsPresenceDate", { process: this.model, documentCode: "TD15" });
			}

			this.abertaField = false;
		}

		EventBus.$on("Operational.imp.form.general.changeWayOfTransport", () => {
			this.changeWayOfTransport();
		});
	},
	beforeDestroy() {
		EventBus.$off("Operational.imp.form.general.changeWayOfTransport");
	},
	watch: {
		'model.priority'(val) {
			this.priorityReady = false;
			setTimeout(() => {
				this.priorityReady = !!val;
			}, 300);
			setTimeout(() => {
				if(val === false && this.model.priorityTypes != null && this.model.priorityTypes.length > 0) {
					this.model.priorityTypes = [];
					this.diffObjects('priorityTypes');
				}
			}, 400);
		},
		process: async function () {
			this.model = {
				...this.process,
				afrmmPaymentDate: this.parseApiDateOnlyToLocalDate(
					this.process.afrmmPaymentDate ?? null
				),
				integrationAFRMMValue: this.process.integrationAFRMMValue ?? 0,
				invoiceTotal: this.process.invoiceTotal ?? 0,
				cifValue: this.process.cifValue ?? 0,
				billingOutgoingNFTotalValue:
					this.process.billingOutgoingNFTotalValue ?? 0,
			};
			this.$set(
				this.model,
				"ceMercanteChecked",
				this.normalizeCeMercanteChecked(this.model.ceMercanteChecked)
			);
			this.initialModel = {
				...this.model,
			};

			const integrationCustomValueIsEmpty =
				this.model.integrationCustomsValue === null ||
				this.model.integrationCustomsValue === "" ||
				this.model.integrationCustomsValue === 0;

			if (this.model.datesETA !== null && this.model.datesETA !== "") {
				this.model.estimatedStepCashRequest = this.model.datesETA;
			}

			if (
				this.model.billingNFsDate !== null &&
				this.model.billingNFsDate !== "" &&
				this.process.customer &&
				this.process.customer.id == 100 &&
				integrationCustomValueIsEmpty &&
				this.process.wayOfTransport === "MARITIMA"
			) {
				let fieldsWithoutValue = [];

				if (integrationCustomValueIsEmpty) {
					fieldsWithoutValue.push("Despesas Aduaneiras");
				}

				let message = `${fieldsWithoutValue.length > 1 ? "Os Campos" : "O Campo "
					} ${fieldsWithoutValue.join(", ")} ${fieldsWithoutValue.length > 1
						? " devem ser preenchidos"
						: " deve ser preenchido"
					}`;

				Swal.fire({
					title: "Preenchimento da Data de ",
					html: message,
					type: "warning",
				});
			}
		},
	},
};
</script>

<style scoped>
.add-new-contact {
	border: 0;
	cursor: pointer;
	background-color: #5b93d3;
	color: #ffffff;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.check-toggle {
	padding: 4px 15px !important;
}

.limited {
	cursor: pointer !important;
}

/* Grupo genérico: cabeçalho (rótulo + ação) + linha (campo principal + secundário) */
.form-field-inline-group {
	margin-bottom: 0.5rem;
}

.form-field-inline-group__head {
	width: 100%;
	gap: 0.35rem;
	margin-bottom: 0.12rem;
	line-height: 1.15;
}

.form-field-inline-group__label {
	flex: 1 1 auto;
	min-width: 0;
	line-height: 1.15;
	padding-top: 0;
	padding-bottom: 0;
}

.form-field-inline-group__action {
	flex: 0 0 auto;
	margin-left: auto;
	line-height: 1.15;
	font-size: 0.8125rem;
}

.form-field-inline-group__row {
	width: 100%;
	flex-wrap: nowrap;
	gap: 0.35rem;
	min-width: 0;
	align-items: center;
}

.form-field-inline-group__primary .form-control {
	padding: 0.2rem 0.45rem;
	font-size: 0.875rem;
	line-height: 1.25;
	min-height: 0;
	height: auto;
}

.form-field-inline-group__primary {
	min-width: 0;
	flex: 1 1 0;
}

.form-field-inline-group__secondary {
	flex: 0 0 auto;
	width: auto;
	max-width: 100%;
	min-width: 0;
}

.input-group-solved-center.datetime {
	position: relative;
}

.billing-nf-emission-date-input {
	cursor: pointer;
	background-color: #fff;
	padding-right: 28px;
}

.billing-nf-emission-date-input:disabled {
	cursor: not-allowed;
	background-color: #f5f5f5;
}

.billing-nf-emission-date-clear {
	position: absolute;
	right: 6px;
	top: 50%;
	transform: translateY(-50%);
	border: 0;
	background: transparent;
	color: #999;
	padding: 0 4px;
	line-height: 1;
	cursor: pointer;
}

.billing-nf-emission-date-clear:hover {
	color: #666;
}

.billing-nf-emission-date-picker.mx-datepicker {
	width: 100%;
	display: block;
}

.billing-nf-emission-date-modal-fields .form-group {
	margin-bottom: 12px;
	position: relative;
	overflow: visible;
}

.billing-nf-emission-date-modal-fields .form-group.mg-b-0 {
	margin-bottom: 0;
}

.channel-parameterization-banner {
	display: flex;
	align-items: center;
	padding: 12px 14px;
	border-radius: 4px;
	font-size: 14px;
	line-height: 1.4;
	background-color: #f4f6f8;
	color: #424651;
	border-left: 4px solid #1C3B70;
}

.channel-parameterization-banner--amarelo {
	background-color: #fff8e8;
	border-left-color: #f0ad4e;
	color: #8a6d3b;
}

.channel-parameterization-banner--vermelho {
	background-color: #fdecea;
	border-left-color: #dc3545;
	color: #a94442;
}

.channel-parameterization-banner--cinza {
	background-color: #f0f0f0;
	border-left-color: #6c757d;
	color: #555;
}

.channel-parameterization-modal .v-select-wrapper {
	margin-bottom: 0;
}

.status-field--operation {
	background-color: #f6f9fd;
}

.status-field--quick {
	background-color: #faf8fc;
}

.status-field--broker {
	background-color: #fdfcf8;
}
</style>

<style>
.billing-nf-emission-date-modal-fields .mx-datepicker-popup,
.v-modal-container.remove-overflow .mx-datepicker-popup {
	z-index: 100001;
}

.input-way-of-transport .vs__selected-options {
	flex-wrap: nowrap;
}

.input-way-of-transport .vs__selected-options .selected-tag {
	min-width: 95px;
}

</style>
